export const uzResources = {
  translation: {
    common: {
      languages: {
        uz: "O'zbekcha (lotin)",
        "uz-cyrl": "O'zbekcha (kirill)",
        ru: "Русский",
        en: "English",
      },
      languageShort: {
        uz: "UZ",
        "uz-cyrl": "UZ-K",
        ru: "RU",
        en: "EN",
      },
      actions: {
        goHome: "Bosh sahifaga qaytish",
        tryAgain: "Qayta urinish",
        backToFiles: "XLS fayllarga qaytish",
        backToImports: "Importlarga qaytish",
        refresh: "Yangilash",
        chooseFile: "Fayl tanlash",
        changeFile: "Faylni almashtirish",
        startImport: "Importni boshlash",
        inspect: "Ko'rish",
        openItems: "Elementlarni ochish",
        login: "Kirish",
        register: "Ro'yxatdan o'tish",
        forgotPassword: "Parolni unutdingizmi?",
        backToLogin: "Kirish sahifasiga qaytish",
        restoreDefaults: "Standart sozlamalarni qaytarish",
        remove: "O'chirish",
        more: "Boshqa amallar",
        cancel: "Bekor qilish",
        back: "Orqaga",
        clear: "Tozalash",
      },
      copy: {
        copy: "Nusxalash",
        copyLabeled: "«{{label}}» nusxasini olish",
        copied: "Buferga nusxalandi",
        copiedLabeled: "{{label}} nusxalandi",
      },
      rateLimit: {
        message: "Juda ko'p so'rov. {{time}} kuting.",
        seconds: "{{count}} soniya",
        minutes: "{{count}} daqiqa",
      },
      account: {
        account: "Hisob",
        billing: "To'lovlar",
        notifications: "Bildirishnomalar",
        myOrganization: "Mening tashkilotim",
        logOut: "Chiqish",
        authenticated: "tasdiqlangan",
        user: "foydalanuvchi",
        organization: "tashkilot {{id}}",
      },
      states: {
        searching: "Qidirilmoqda...",
        loading: "Yuklanmoqda...",
        noData: "Ma'lumot yo'q",
        latest: "So'nggi",
        none: "Yo'q",
        processing: "jarayonda",
        queued: "navbatda",
        finished: "Tugallandi",
      },
      currency: {
        som: "so'm",
      },
      table: {
        firstPage: "Birinchi sahifa",
        prevPage: "Oldingi sahifa",
        nextPage: "Keyingi sahifa",
        lastPage: "Oxirgi sahifa",
      },
      routeError: {
        title: "Xatolik yuz berdi",
        description: "Sahifani yuklab bo'lmadi. Iltimos, qayta urinib ko'ring.",
        retry: "Qayta urinish",
      },
    },
    navigation: {
      new: "Yangi",
      groups: {
        main: "Asosiy",
        organizations: "Tashkilotlar",
        pricing: "Narxlar",
        authentication: "Autentifikatsiya",
      },
      items: {
        medicines: "Dorilar",
        wholesaleOffers: "Ulgurji takliflar",
        priceAnalysis: "Narx tahlili",
        priceTrends: "Narx dinamikasi",
        organizations: "Tashkilotlar",
        organizationRatings: "Tashkilotlar reytingi",
        organizationImport: "Import",
        organizationEdit: "Mening tashkilotim",
        vendors: "Ishlab chiqaruvchilar",
        certifiedMedicines: "Sertifikatlar",
        referentPrices: "Referent narxlar",
        orders: "Buyurtmalar",
        cart: "Savat",
        default: "Asosiy",
        crm: "CRM",
        analytics: "Analitika",
        pharmacy: "Dorixona",
        ecommerce: "E-Commerce",
        academy: "Akademiya",
        logistics: "Logistika",
        loginV1: "Kirish v1",
        loginV2: "Kirish v2",
        registerV1: "Ro'yxatdan o'tish v1",
        registerV2: "Ro'yxatdan o'tish v2",
      },
    },
    layout: {
      search: {
        button: "Qidirish",
        placeholder: "Dashboard, foydalanuvchi va boshqalarni qidiring…",
        empty: "Hech narsa topilmadi.",
        quickCreate: "Tez yaratish",
        inbox: "Kiruvchi xatlar",
        shortcut: "Qidiruv",
        soon: "Tez kunda",
      },
      preferences: {
        title: "Sozlamalar",
        description: "Dashboard ko'rinishi sozlamalarini moslang.",
        storageNote:
          "Sozlamalar odatda cookie orqali saqlanadi. Kod ichida cookies, localStorage yoki saqlamaslik rejimini tanlashingiz mumkin.",
        themePreset: "Tema preset",
        presetPlaceholder: "Preset",
        fonts: "Shriftlar",
        fontPlaceholder: "Shriftni tanlang",
        themeMode: "Tema rejimi",
        pageLayout: "Sahifa layouti",
        navbarBehavior: "Navbar xatti-harakati",
        sidebarStyle: "Sidebar uslubi",
        sidebarCollapseMode: "Sidebar yig'ilish rejimi",
        modes: {
          light: "Yorug'",
          dark: "Qorong'i",
          system: "Tizim",
        },
        layoutOptions: {
          centered: "Markazlashgan",
          fullWidth: "To'liq kenglik",
        },
        navbarOptions: {
          sticky: "Mahkam",
          scroll: "Skroll",
        },
        sidebarOptions: {
          inset: "Inset",
          sidebar: "Sidebar",
          floating: "Suzuvchi",
        },
        collapseOptions: {
          icon: "Ikona",
          offcanvas: "Yashirin panel",
        },
      },
      medicineSearch: {
        button: "Dori qidirish",
        title: "Dori topish",
        recent: "So'nggi qidiruvlar",
      },
      languageSelector: {
        placeholder: "Til",
        ariaLabel: "Ilova tili",
      },
      themeSwitcher: {
        ariaLabel: "Joriy tema: {{theme}}. Keyingi temaga o'tish uchun bosing",
      },
    },
    auth: {
      checkingSession: "Sessiya tekshirilmoqda...",
      login: {
        title: "Hisobingizga kiring",
        description: "Kirish uchun ma'lumotlaringizni kiriting.",
        phone: "Telefon raqami",
        password: "Parol",
        submit: "Kirish",
        submitting: "Kirilmoqda...",
        success: "Muvaffaqiyatli kirildi.",
        invalidPhone: "Telefon 998XXXXXXXXX formatida bo'lishi kerak.",
        passwordRequired: "Parol kiritilishi shart.",
        failed: "Hozir tizimga kirib bo'lmadi.",
        modes: {
          password: "Parol",
          otp: "Telegram",
          switchToPassword: "Parol bilan kirish",
          switchToOtp: "Telegram orqali kirish",
        },
        noAccount: "Akkauntingiz yo'qmi?",
        errors: {
          invalidCredentials: "Telefon yoki parol noto'g'ri.",
          tooManyAttempts: "Juda ko'p urinish, 15 daqiqadan keyin urinib ko'ring.",
          userNotFound: "Bu telefon ro'yxatdan o'tmagan, avval ro'yxatdan o'ting.",
          tooManyOtp: "Juda ko'p urinish, keyinroq qayta urinib ko'ring.",
          notTelegram: "Bu raqamda Telegram yo'q. Parol bilan kiring.",
          sendFailed: "Kodni yuborib bo'lmadi. Keyinroq qayta urinib ko'ring.",
          codeInvalid: "Kod noto'g'ri. Qaytadan urinib ko'ring.",
          codeExpired: "Kod muddati tugadi yoki urinishlar tugadi. Qayta boshlang.",
          verifyFailed: "Kodni tasdiqlab bo'lmadi. Qaytadan urinib ko'ring.",
          network: "Internet ulanishini tekshiring.",
          generic: "Kutilmagan xato. Qaytadan urinib ko'ring.",
        },
        otp: {
          phaseATitle: "Telegram orqali kirish",
          phaseADescription: 'Telefoningizni kiriting — Telegram\'dagi "Verification Codes" chatga kod yuboramiz.',
          phaseBTitle: "Kodni kiriting",
          phaseBDescription: 'Telegram\'dagi "Verification Codes" chatga kod yuborildi.',
          sendCode: "Kod yuborish",
          sending: "Yuborilmoqda...",
          codeLabel: "Tasdiqlash kodi",
          verify: "Tasdiqlash",
          verifying: "Tasdiqlanmoqda...",
          resend: "Kodni qayta yuborish",
          resendIn: "Qayta yuborish ({{time}})",
          otherPhone: "Boshqa raqam",
          sentTo: "Yuborildi: {{phone}}",
        },
      },
      register: {
        title: "Hisob yarating",
        description: "Ro'yxatdan o'tish uchun ma'lumotlaringizni kiriting.",
        otpDescription: "SMS orqali 6 xonali tasdiqlash kodi yuborildi.",
        language: "Til",
        languagePlaceholder: "Tilni tanlang",
        languageRequired: "Iltimos, tilni tanlang.",
        firstName: "Ism",
        lastName: "Familiya",
        phone: "Telefon raqami",
        password: "Parol",
        passwordConfirm: "Parolni tasdiqlang",
        showPassword: "Parolni ko'rsatish",
        hidePassword: "Parolni yashirish",
        submit: "Ro'yxatdan o'tish",
        submitting: "Yuborilmoqda...",
        success: "Muvaffaqiyatli ro'yxatdan o'tildi.",
        failed: "Hozir ro'yxatdan o'tib bo'lmadi.",
        alreadyHaveAccount: "Hisobingiz bormi?",
        firstNameRequired: "Ismni kiriting.",
        firstNameMax: "Ism 100 belgidan oshmasligi kerak.",
        lastNameRequired: "Familiyani kiriting.",
        lastNameMax: "Familiya 100 belgidan oshmasligi kerak.",
        invalidPhone: "Telefon 998XXXXXXXXX formatida bo'lishi kerak.",
        passwordRequired: "Parol kiritilishi shart.",
        passwordMin: "Parol kamida 8 ta belgidan iborat bo'lishi kerak.",
        passwordConfirmRequired: "Parolni tasdiqlang.",
        passwordsMismatch: "Parollar mos emas.",
        organizationInn: "Tashkilot INN",
        organizationInnHint: "Tashkilot ma'lumotlari avtomatik to'ldirilishi uchun 9 xonali INN kiriting.",
        organizationInnInvalid: "INN aniq 9 ta raqamdan iborat bo'lishi kerak.",
        organizationInnLookupLoading: "Tashkilot izlanmoqda…",
        organizationInnLookupNotFound: "Ushbu INN bo'yicha tashkilot topilmadi.",
        organizationInnLookupFailed: "Ma'lumotlarni olib bo'lmadi. Iltimos, qo'lda kiriting.",
        organizationName: "Tashkilot nomi",
        organizationNameRequired: "Tashkilot nomini kiriting.",
        organizationNameMax: "Tashkilot nomi 255 belgidan oshmasligi kerak.",
        organizationAddress: "Manzil",
        organizationAddressMax: "Manzil 500 belgidan oshmasligi kerak.",
        organizationSection: "Tashkilot",
        modeCreateTitle: "Yangi tashkilot yaratish",
        modeCreateDescription: "O'z dorixonangiz yoki omboringizni sozlang.",
        modeJoinTitle: "Mavjud tashkilotga qo'shilish",
        modeJoinDescription: "Tashkilot egasiga so'rov yuboring.",
        modeJoinHint: "Ro'yxatdan o'tgach, qo'shilish uchun tashkilotni tanlang.",
        errors: {
          alreadyRegistered: "Bu telefon allaqachon ro'yxatdan o'tgan.",
          loginLink: "Kirish",
          tooManyRequests: "Juda ko'p urinish, keyinroq qayta urinib ko'ring.",
          sendFailed: "Kodni yuborib bo'lmadi. Keyinroq qayta urinib ko'ring.",
          generic: "Kutilmagan xato. Qaytadan urinib ko'ring.",
          network: "Internet ulanishini tekshiring.",
          organizationFailed: "Hisob yaratildi, lekin tashkilotni yaratib bo'lmadi. Keyinroq yaratishingiz mumkin.",
        },
      },
      forgotPassword: {
        title: "Parolni tiklash",
        description: "Telefon raqamingizni kiriting, kodni tasdiqlang va yangi parol o'rnating.",
        otpDescription: "SMS orqali 6 xonali tasdiqlash kodi yuborildi.",
        phone: "Telefon raqami",
        newPassword: "Yangi parol",
        passwordConfirm: "Parolni tasdiqlang",
        submit: "Kod yuborish",
        submitting: "Yuborilmoqda...",
        resetSubmit: "Parolni yangilash",
        success: "Parol yangilandi. Yangi parol bilan kirishingiz mumkin.",
        invalidPhone: "Telefon 998XXXXXXXXX formatida bo'lishi kerak.",
        passwordRequired: "Parol talab qilinadi.",
        passwordMin: "Parol kamida 8 ta belgidan iborat bo'lishi kerak.",
        passwordConfirmRequired: "Parolni tasdiqlang.",
        passwordsMismatch: "Parollar mos kelmaydi.",
        errors: {
          userNotFound: "Bu telefon ro'yxatdan o'tmagan.",
          tooManyRequests: "Juda ko'p urinish, keyinroq qayta urinib ko'ring.",
          sendFailed: "Kodni yuborib bo'lmadi. Keyinroq qayta urinib ko'ring.",
          codeExpired: "Kod muddati tugadi yoki urinishlar tugadi. Qaytadan boshlang.",
          codeInvalid: "Noto'g'ri tasdiqlash kodi. Qaytadan urinib ko'ring.",
          network: "Internet ulanishini tekshiring.",
          generic: "Kutilmagan xato. Qaytadan urinib ko'ring.",
        },
      },
    },
    landing: {
      nav: {
        platform: "Platforma",
        data: "Ma'lumotlar",
        activity: "Faoliyat",
        login: "Kirish",
        getStarted: "Boshlash",
      },
      hero: {
        badge: "O'zbekiston farmatsevtika bozori tahlili",
        title1: "Haqiqiy narxni biling",
        title2: "sotib olishdan oldin",
        subtitle:
          "PharmaLogic har kuni O'zbekiston bo'ylab ulgurji sotuvchilardan dori narxlarini yig'adi va tahlil qiladi — dorixonalar takliflarni solishtirishi, trendlarni kuzatishi va samarali xarid qilishi uchun.",
        cta: "Dashboardni ochish",
        ctaSecondary: "Qanday ishlashini ko'ring",
        trustRegions: "Viloyat qamrovi",
        trustUpdates: "Ma'lumot yangilanishi",
        trustFree: "Bepul kirish",
      },
      problem: {
        badge: "Muammo",
        title: "Dorixonalar bugun dorilarni qanday sotib oladi",
        before: "PharmaLogic'siz",
        after: "PharmaLogic bilan",
        pain1: "Har kuni ertalab o'nlab yetkazib beruvchining narx ro'yxatini Telegram'da qo'lda tekshirish",
        pain2: "Standart formati yo'q Excel fayllarda narxlarni solishtirish",
        pain3: "Bozorning yagona ko'rinishi yo'qligi sababli yaxshi narxlarni o'tkazib yuborish",
        pain4: "Oxirgi haftalarda narx ko'tarilgan yoki tushganini bilishning iloji yo'q",
        gain1: "Barcha yetkazib beruvchilar narxlari har kuni avtomatik yig'iladi va tartiblanadi",
        gain2: "Bitta qidiruv bilan barcha ulgurji sotuvchilar bo'ylab takliflarni solishtirish",
        gain3: "Narx trendlari va tarixiy ma'lumotlar — hozir sotib olish to'g'ri vaqtmi bilish uchun",
        gain4: "Aksiyalar va muddati tugayotgan takliflar haqida xabarlar",
      },
      showcase: {
        badge: "Mahsulot",
        title: "Dorixona xarid guruhlari uchun yaratilgan",
        subtitle:
          "Dorilarni qidirish, ulgurji narxlarni solishtirish, trendlarni kuzatish va buyurtmalar berish — barchasi bir joyda.",
      },
      howItWorks: {
        badge: "Qanday ishlaydi",
        title: "Xom narx ro'yxatlaridan aqlli qarorlarga",
        subtitle:
          "Biz qiyin ishni qilamiz — siz eng muhimga e'tibor qarating: dorixonangiz uchun eng yaxshi narxlarni olish.",
        step1Title: "Ma'lumotlarni yig'amiz",
        step1Desc:
          "Har kuni tizimimiz yetkazib beruvchilarning Telegram kanallaridan narx ro'yxatlarini tortib oladi va Excel fayllarni avtomatik qayta ishlaydi.",
        step2Title: "Tozalaymiz va tartiblaymiz",
        step2Desc:
          "Xom ma'lumotlar dori bazamizga moslanadi, narxlar tekshiriladi, anomaliyalar belgilanadi va kunlik agregatlar hisoblanadi.",
        step3Title: "Siz yaxshiroq qaror qabul qilasiz",
        step3Desc:
          "Istalgan dorini qidiring, barcha takliflarni narx bo'yicha ko'ring, trendni tekshiring va buyurtmangizga qo'shing — soatlarda emas, soniyalarda.",
      },
      coverage: {
        badge: "Butun mamlakat qamrovi",
        title: "O'zbekistonning har bir burchagini qamrab oladi",
        subtitle:
          "Ma'lumotlar barcha 13 viloyatdan keladi. Toshkentdagi dorixona bo'lsangiz ham, Nukusdagi bo'lsangiz ham — bir xil to'liq bozor manzarasini ko'rasiz.",
        pharmacies: "Kuzatilgan dorixonalar",
        wholesalers: "Ulgurji sotuvchilar",
        regions: "Viloyatlar",
        vendors: "Ishlab chiqaruvchilar",
      },
      stats: {
        badge: "Jonli bozor ma'lumotlari",
        title1: "Bozor raqamlarda",
        title2: "har kuni yangilanadi",
        subtitle:
          "Biz mamlakat bo'ylab har bir dori, ulgurji taklif va narx o'zgarishini kuzatamiz — hozirgi ma'lumotlar shunday ko'rinadi.",
        medicines: "Bazadagi dorilar",
        vendors: "Ishlab chiqaruvchilar",
        pharmacies: "Chakana dorixonalar",
        wholesalers: "Tasdiqlangan ulgurji sotuvchilar",
        offers: "Faol ulgurji takliflar",
        coverage: "Ulgurji narx qamrovi",
      },
      features: {
        badge: "PharmaLogic nima hal qiladi",
        title1: "Dorixona xaridlari",
        title2: "taxminsiz",
        priceCompare: "Narxlarni solishtirish",
        priceCompareDesc:
          "Barcha yetkazib beruvchilarning ulgurji narxlarini yonma-yon ko'ring. Har bir dori uchun eng yaxshi taklifni bir zumda toping.",
        trends: "Narx trendlarini kuzatish",
        trendsDesc:
          "Kunlik narx agregatlari narxlar qachon ko'tarilishi, tushishi yoki barqaror qolishini ko'rsatadi. Mavsumiy naqshlarni erta aniqlang.",
        coverage: "Butun mamlakat qamrovi",
        coverageDesc:
          "O'zbekistonning barcha 13 viloyatidan ma'lumotlar. Chakana dorixonalar, ulgurji distribyutorlar va ishlab chiqaruvchilar — barchasi bir joyda.",
        realtime: "Kunlik yangilanish",
        realtimeDesc:
          "Narx ro'yxatlari yetkazib beruvchilarning Telegram kanallaridan yig'iladi va har kuni avtomatik qayta ishlanadi.",
        search: "Aqlli dori qidiruvi",
        searchDesc:
          "Har qanday dorini savdo nomi, xalqaro nomi, dozaj shakli yoki kuchi bo'yicha toping. Avtoto'ldirish tezkor qiladi.",
        wholesale: "Ulgurji taklif tahlili",
        wholesaleDesc:
          "Takliflarni to'lov shartlari, yaroqlilik muddati va aksiyalar bilan solishtiring. Viloyat yoki yetkazib beruvchi bo'yicha filtrlang.",
        analytics: "Bozor tahlili",
        analyticsDesc:
          "Dashboard darajasidagi KPI: bozor hajmi, qamrov darajasi, yetkazib beruvchi faolligi va boshqalar.",
        orders: "Buyurtmalarni boshqarish",
        ordersDesc:
          "Eng yaxshi ulgurji takliflardan buyurtmalar tuzing, bajarilishini kuzating va xarid jarayonini boshqaring.",
      },
      activity: {
        badge: "30 kunlik faoliyat",
        title: "Bozor faolligi",
        subtitle:
          "Barcha kuzatilayotgan yetkazib beruvchilar bo'ylab kunlik ulgurji faoliyat — e'lon qilingan takliflar, faol yetkazib beruvchilar va aksiyalar.",
        offers: "Ulgurji takliflar",
        suppliers: "Yetkazib beruvchi yangilanishlari",
        wholesalers: "Faol ulgurji sotuvchilar",
        promos: "Aksiyalar",
        unavailableTitle: "Bozor ma'lumotlari vaqtincha mavjud emas",
        unavailableDescription: "Analitika ma'lumotlari qayta mavjud bo'lganda faollik trendlari shu yerda ko'rinadi.",
      },
      cta: {
        title1: "Samarali xaridlarni",
        title2: "boshlang",
        subtitle: "O'zbekiston bo'ylab dori narxlari, ulgurji takliflar va bozor tahlillariga bepul kirish.",
        login: "Kirish",
        register: "Hisob yaratish",
      },
      footer: {
        rights: "Barcha huquqlar himoyalangan.",
        tagline: "O'zbekiston farmatsevtika bozori uchun aqlli tahlil platformasi.",
        quickLinks: "Tezkor havolalar",
        contact: "Aloqa",
        poweredBy: "Powered by",
        privacy: "Maxfiylik siyosati",
        accountDeletion: "Akkauntni o'chirish",
      },
      privacy: {
        title: "Maxfiylik siyosati",
        lastUpdated: "Oxirgi yangilanish: 2026 yil 27 aprel",
        backHome: "Bosh sahifaga qaytish",
        intro:
          "PharmaLogic ('biz', 'bizning') sizning maxfiyligingizni hurmat qiladi. Ushbu Maxfiylik siyosati biz sizning shaxsiy ma'lumotlaringizni qanday yig'ishimiz, ulardan foydalanishimiz va ularni himoya qilishimizni tushuntiradi. Platformadan foydalanish orqali siz ushbu shartlarga roziligingizni bildirasiz.",
        s1Title: "1. Yig'iladigan ma'lumotlar",
        s1Body:
          "Hisob ma'lumotlari: telefon raqami, ism, tashkilot nomi va elektron pochta. Foydalanish ma'lumotlari: qidiruv tarixi, ko'rilgan dorilar, savatdagi mahsulotlar va buyurtmalar. Qurilma ma'lumotlari: brauzer turi, IP-manzil va mahalliy keshlangan hisob/sessiya holati. Ulgurji yetkazib beruvchi ma'lumotlari ochiq Telegram kanallaridan yig'iladi va biznes ma'lumotlari hisoblanadi (shaxsiy emas).",
        s2Title: "2. Ma'lumotlardan foydalanish",
        s2Body:
          "Tahliliy xizmatlarimizni taqdim etish va yaxshilash, foydalanuvchilarni autentifikatsiya qilish va hisoblarni himoya qilish, narx o'zgarishi, aksiyalar va muddati tugashi haqida bildirishnomalar yuborish, foydalanuvchi so'rovlariga javob berish hamda qonuniy majburiyatlarga rioya qilish uchun.",
        s3Title: "3. Ma'lumotlarni ulashish",
        s3Body:
          "Biz shaxsiy ma'lumotlaringizni hech qachon sotmaymiz. Xizmat ko'rsatuvchi sheriklarimiz (masalan, hosting provayderlari va OTP uchun SMS shlyuzlari) bilan ulashishimiz mumkin. Qonun talab qilgan hollarda yoki huquq-tartibot organlarining qonuniy talabiga binoan ma'lumotlarni oshkor qilishimiz mumkin.",
        s4Title: "4. Cookie-fayllar va mahalliy saqlash",
        s4Body:
          "Sessiyangiz uchun HttpOnly autentifikatsiya cookie-faylidan foydalanamiz. Brauzer localStorage'i interfeys sozlamalari va maxfiy bo'lmagan keshlangan hisob holatini saqlaydi. Uchinchi tomon reklama yoki kuzatuv cookie-fayllaridan foydalanmaymiz.",
        s5Title: "5. Ma'lumotlar xavfsizligi",
        s5Body:
          "Barcha ma'lumotlar HTTPS orqali shifrlangan kanal bo'ylab uzatiladi. Autentifikatsiya xavfsiz cookie-fayllar va yozish amallari uchun idempotensiya kalitlari yordamida amalga oshiriladi. Tizimimizni muntazam xavfsizlik tekshiruvidan o'tkazamiz va kirishni cheklangan xodimlar doirasida saqlaymiz.",
        s6Title: "6. Sizning huquqlaringiz",
        s6Body:
          "Siz ma'lumotlaringizga kirish, ularni ko'rish va hisob sozlamalari orqali tuzatish huquqiga egasiz. Hisobingizni va u bilan bog'liq barcha ma'lumotlarni istalgan vaqtda o'chirib tashlashingiz mumkin. Ma'lumotlarga ishlov berishga bergan roziligingizni qaytarib olish ham huquqingiz.",
        s7Title: "7. Ma'lumotlarni saqlash muddati",
        s7Body:
          "Hisob ma'lumotlari siz o'chirishni so'ramaguningizgacha saqlanadi. Anonim agregat tahliliy ma'lumotlar platformani yaxshilash uchun aniqlanmaydigan shaklda saqlanishi mumkin.",
        s8Title: "8. Bolalar maxfiyligi",
        s8Body:
          "PharmaLogic dorixonalar va ulgurji sotuvchilar uchun B2B platformasi sifatida mo'ljallangan. Xizmat 18 yoshgacha bo'lgan shaxslarga qaratilmagan va biz bilib turib bolalardan ma'lumot to'plamaymiz.",
        s9Title: "9. Siyosatga kiritiladigan o'zgarishlar",
        s9Body:
          "Biz ushbu Maxfiylik siyosatini vaqti-vaqti bilan yangilashimiz mumkin. Eng so'nggi tahrir sanasi yuqorida ko'rsatilgan. Muhim o'zgarishlar haqida sizni elektron pochta yoki platforma orqali xabardor qilamiz. O'zgarishlardan keyin xizmatdan foydalanishni davom ettirish yangilangan siyosatga rozilik bildirilganini anglatadi.",
        s10Title: "10. Biz bilan bog'lanish",
        s10Body: "Maxfiylik bilan bog'liq savollar yoki so'rovlar uchun biz bilan bog'laning:",
      },
      privacyMobile: {
        title: "Maxfiylik siyosati",
        lastUpdated: "Oxirgi yangilanish: 2026-yil 29-may",
        backHome: "Bosh sahifaga",
        intro:
          "Ushbu Maxfiylik siyosati PharmaLogic mobil ilovasi («biz», «bizning») sizning ma'lumotlaringizni qanday to'plashi, ishlatishi va himoya qilishini tavsiflaydi. Ilovani o'rnatib va undan foydalanib, siz ushbu siyosatga rozilik bildirasiz.",
        s1Title: "1. Biz to'playdigan ma'lumotlar",
        s1Body:
          "Ro'yxatdan o'tishda siz kiritadigan hisob ma'lumotlari: ism va familiya, telefon raqami va parol. Telefon raqamingiz bir martalik SMS-kod (OTP) orqali tasdiqlanadi. Foydalanish ma'lumotlari: dori qidiruvlari, ko'rilgan dorilar, saqlangan sevimlilar va xatcho'plar, savatcha tarkibi. Qurilma ma'lumotlari: qurilma modeli, operatsion tizim versiyasi, ilova versiyasi, til va push-bildirishnoma tokeni.",
        s2Title: "2. Joylashuv ma'lumotlari",
        s2Body:
          "Sizning ruxsatingiz bilan ilova yaqin atrofdagi aptekalarni topish va ulargacha bo'lgan masofani ko'rsatish uchun taxminiy yoki aniq joylashuvingizdan foydalanadi. Joylashuv faqat xarita va qidiruvdan foydalanganda qayta ishlanadi va hech qachon reklama uchun ishlatilmaydi. Joylashuvga ruxsatni istalgan vaqtda qurilma sozlamalarida berishingiz yoki bekor qilishingiz mumkin; ilova usiz ham ishlayveradi.",
        s3Title: "3. Ma'lumotlardan qanday foydalanamiz",
        s3Body:
          "Dorilarning mavjudligi va yaqin aptekalarni ko'rsatish, sizni autentifikatsiya qilish va hisobingizni himoya qilish, sevimlilar, xatcho'plar va savatchani saqlash, siz yoqgan bildirishnomalarni yuborish, murojaatlaringizga javob berish va ilovani yaxshilash uchun.",
        s4Title: "4. Push-bildirishnomalar",
        s4Body:
          "Agar bildirishnomalarni yoqsangiz, sizga tegishli xabarlarni yuborish uchun qurilmaning push-tokenini ro'yxatdan o'tkazamiz. Push-xabarlar Expo push-xizmati hamda Apple va Google bildirishnoma tizimlari orqali yetkaziladi. Bildirishnomalarni istalgan vaqtda qurilma sozlamalarida o'chirib qo'yishingiz mumkin.",
        s5Title: "5. Apteka haqida shikoyat yuborish",
        s5Body:
          "Apteka yoki e'lon haqida shikoyat yuborganingizda biz tanlangan sabab, tegishli apteka va dori identifikatorlari, ixtiyoriy izohingiz va bog'lanish uchun ixtiyoriy telefon raqamini to'playmiz. Bu ma'lumot faqat ko'rsatilgan e'lonni tekshirish va tuzatish uchun ishlatiladi.",
        s6Title: "6. Ma'lumotlarni ulashish",
        s6Body:
          "Biz hech qachon shaxsiy ma'lumotlaringizni sotmaymiz. Biz ma'lumotlarni bizning nomimizdan ish yurituvchi xizmat ko'rsatuvchilarga — masalan, hosting provayderlari, OTP yetkazish uchun SMS-shlyuz va push-bildirishnoma xizmatiga ulashishimiz mumkin. Qonun yoki vakolatli organlarning asosli so'rovi talab qilganda ma'lumotni oshkor qilishimiz mumkin.",
        s7Title: "7. Uchinchi tomon xarita va navigatsiya xizmatlari",
        s7Body:
          "Ilova Google Maps yordamida ichki xaritani ko'rsatadi. Yo'nalish olish yoki aptekaga qo'ng'iroq qilishni tanlaganingizda, ilova siz tanlagan tashqi ilovani — masalan, Google Maps, Yandex Maps, Yandex Navigator, Yandex Go yoki 2GIS, yoki telefon tergichni ochadi. Bu ilovalar o'zlarining maxfiylik siyosatlariga bo'ysunadi.",
        s8Title: "8. Ma'lumotlar xavfsizligi",
        s8Body:
          "Barcha ma'lumotlar shifrlangan HTTPS ulanishlari orqali uzatiladi. Autentifikatsiya tokenlari qurilmangizning xavfsiz xotirasida (iOS Keychain / Android Keystore) saqlanadi. Biz ichki kirishni cheklaymiz va tizimlarimizni muntazam tekshiramiz.",
        s9Title: "9. Sizning huquqlaringiz",
        s9Body:
          "Hisob ma'lumotlaringizni ilovada ko'rishingiz va tuzatishingiz mumkin. Istalgan vaqtda hisobingizni va unga bog'liq barcha ma'lumotlarni o'chirishingiz, shuningdek joylashuv va bildirishnomalar kabi ruxsatlarni qurilma sozlamalarida bekor qilishingiz mumkin.",
        s10Title: "10. Ma'lumotlarni saqlash",
        s10Body:
          "Hisob ma'lumotlaringizni o'chirishni so'ramaguningizcha saqlaymiz. Qidiruv tarixi kabi mahalliy saqlangan ma'lumotlarni ilovaning o'zida tozalash mumkin. Ilovani yaxshilash uchun anonim, umumlashtirilgan statistika shaxssizlantirilgan shaklda saqlanishi mumkin.",
        s11Title: "11. Bolalar maxfiyligi",
        s11Body:
          "Ilova apteka va dorilar haqida ma'lumot izlovchi keng auditoriya uchun mo'ljallangan. U 13 yoshgacha bo'lgan bolalar uchun mo'ljallanmagan va biz ulardan shaxsiy ma'lumotlarni ataylab to'plamaymiz.",
        s12Title: "12. Biz bilan bog'lanish",
        s12Body: "Maxfiylik bilan bog'liq savollar yoki so'rovlar uchun biz bilan bog'laning:",
      },
      accountDeletion: {
        backHome: "Bosh sahifaga",
        title: "Akkauntni o'chirish",
        intro:
          "PharmaLogic mobil ilovasidagi akkauntingizni va unga bog'liq barcha ma'lumotlarni shu sahifa orqali o'chirishni so'rashingiz mumkin. Telefon raqamingizni kiriting — biz uni SMS-kod orqali tasdiqlaymiz.",
        whatDeletedTitle: "Qanday ma'lumotlar o'chiriladi",
        deletedItem1: "Profil ma'lumotlari: ism, familiya va telefon raqami",
        deletedItem2: "Buyurtmalar va qidiruv tarixi",
        deletedItem3: "Saqlangan sevimlilar va xatcho'plar",
        deletedItem4: "Bildirishnoma sozlamalari va push-tokenlar",
        retainedNote:
          "Qonun talab qiladigan ayrim yozuvlar (masalan, tranzaksiya hujjatlari) shaxssizlantirilgan holda saqlanishi mumkin.",
        graceNote:
          "So'rov tasdiqlangach, akkaunt 3 kun ichida butunlay o'chiriladi. Shu muddat ichida o'chirishni bekor qilishingiz mumkin.",
        phoneLabel: "Telefon raqami",
        invalidPhone: "Telefon raqamini to'g'ri kiriting",
        confirmLabel: "Akkauntimni va barcha ma'lumotlarimni o'chirishni tasdiqlayman",
        confirmRequired: "Davom etish uchun tasdiqlang",
        sendCode: "Kod yuborish",
        sending: "Yuborilmoqda...",
        verifyTitle: "Tasdiqlash kodi",
        codeSentTo: "{{phone}} raqamiga tasdiqlash kodi yuborildi",
        verify: "Tasdiqlash",
        verifying: "Tekshirilmoqda...",
        changePhone: "Telefonni o'zgartirish",
        resend: "Qayta yuborish",
        resendIn: "Qayta yuborish ({{time}})",
        scheduledTitle: "O'chirish rejalashtirildi",
        scheduledMessage: "{{phone}} akkaunti {{date}} sanasida butunlay o'chiriladi.",
        scheduledHint: "Fikringizdan qaytsangiz, shu muddatgacha o'chirishni bekor qilishingiz mumkin.",
        cancelButton: "O'chirishni bekor qilish",
        cancelling: "Bekor qilinmoqda...",
        cancelledTitle: "O'chirish bekor qilindi",
        cancelledMessage: "Akkauntingiz saqlab qolindi. Hech qanday ma'lumot o'chirilmadi.",
      },
    },
    feedback: {
      pageNotFound: {
        title: "Sahifa topilmadi.",
        description: "Siz qidirayotgan sahifa topilmadi.",
      },
      dashboardComingSoon: {
        description: "Bu bo'lim keyingi yangilanishlarda qo'shiladi.",
      },
      pageInDevelopment: {
        description: "Bu sahifa ishlab chiqilmoqda va keyingi yangilanishlarda mavjud bo'ladi.",
      },
      unauthorized: {
        title: "Ruxsatsiz kirish",
        description:
          "Sizda so'ralgan kontentni ko'rish uchun ruxsat yo'q. Agar bu xato deb hisoblasangiz, sayt administratori bilan bog'laning.",
      },
      serverError: {
        title: "Xatolik yuz berdi.",
        description: "Kutilmagan xato yuz berdi. Qayta urinib ko'ring yoki bosh sahifaga qayting.",
      },
      externalLanding: "Tez orada",
      tour: {
        next: "Keyingi",
        prev: "Orqaga",
        done: "Tushunarli",
        skip: "O'tkazib yuborish",
        restart: "Sahifa ekskursiyasini qayta ko'rish",
        progress: "{{current}} / {{total}}",
        wholesaleOffers: {
          toolbar: {
            title: "Filtrlash va qidiruv",
            description: "Bu yerda dori, tashkilot va hududni tanlang. Filtrlar natijalarni darhol yangilaydi.",
          },
          results: {
            title: "Ulgurji takliflar",
            description:
              "Mos keladigan barcha takliflar shu yerda chiqadi. Narx tarixini ko'rish uchun qatorni bosing.",
          },
        },
        certificates: {
          search: {
            title: "Sertifikatlarni qidirish",
            description: "Mahsulot nomi, INN yoki ishlab chiqaruvchini yozing. Bir necha harf ham yetarli.",
          },
          filters: {
            title: "Natijalarni saralash",
            description: "Yil, davlat, sertifikatlovchi organ yoki yaroqlilik muddati bo'yicha filtrlang.",
          },
          results: {
            title: "Sertifikatli dorilar",
            description: "Tafsilotlar uchun qatorni bosing — sertifikat sanasi va qolgan yaroqlilik muddati ko'rinadi.",
          },
        },
        organizations: {
          list: {
            title: "Tashkilotlar ro'yxati",
            description:
              "Barcha ro'yxatdan o'tgan tashkilotlarni ko'ring va qidiring. Profilni ochish uchun bittasini tanlang.",
          },
          detail: {
            title: "Tashkilot ma'lumotlari",
            description:
              "Tanlangan tashkilot ma'lumoti va yuklangan narx ro'yxatlari shu yerda. Hudud yoki to'lov shartlari bo'yicha filtrlang.",
          },
        },
        priceAnalysis: {
          search: {
            title: "Solishtirish uchun dorilarni tanlang",
            description: "Kuzatmoqchi bo'lgan dorilarni qidirib qo'shing. Ular pastdagi jadvalga yig'iladi.",
          },
          compare: {
            title: "Solishtirish jadvali",
            description:
              "Solishtirilayotgan dorilar va joriy narxlar shu yerda. Qatorni bosib asosiy dori sifatida tanlang.",
          },
          trend: {
            title: "Narx dinamikasi",
            description:
              "Grafik ustiga sichqonchani olib boring va sanalar bo'yicha narxni ko'ring. Ulgurji, chakana yoki referent tabini almashtiring.",
          },
        },
        priceTrends: {
          title: "Narx dinamikasi",
          description: "Tanlangan davr bo‘yicha dori narxlari o‘zgarishini solishtiring.",
          window: "Davr",
          windows: { "7": "7 kun", "30": "30 kun", "90": "90 kun" },
          coverage: "Davr: {{start}} – {{end}}",
          coverageUnavailable: "Davr mavjud emas",
          sections: {
            consistent: "Barqaror narx o‘zgarishlari",
            increases: "Narxi eng ko‘p oshganlar",
            decreases: "Narxi eng ko‘p pasayganlar",
            volatile: "Eng o‘zgaruvchan narxlar",
          },
          table: {
            medicine: "Dori",
            coverage: "Davr",
            medianPrice: "Median narx",
            from: "avval",
            metric: "Ko‘rsatkich",
          },
          direction: { rising: "O‘sish", falling: "Pasayish" },
          empty: {
            title: "Bu davr uchun mos dorilar topilmadi.",
            description: "Yetarli narx tarixi mavjud bo‘lgan boshqa davrni tanlang.",
          },
          errorTitle: "Narx dinamikasini yuklab bo‘lmadi",
          errorDescription: "Qaytadan urinib ko‘ring.",
          retry: "Qayta urinish",
        },
      },
    },
    bugReport: {
      label: "Xatolik",
      open: "Xatolik haqida xabar berish",
      tooltip: "Xatolik haqida xabar yoki funksiya so'rovi",
      title: "Xatolik haqida xabar berish",
      description: "Muammo tafsilotlarini jamoamizga yuboring. Imkon bo'lsa skrinshot ham qo'shiladi.",
      submit: "Xabar yuborish",
      submitting: "Yuborilmoqda...",
      successTitle: "Xabar Linear'da yaratildi",
      successToast: "{{issue}} xatolik xabari yaratildi",
      actions: {
        cancel: "Bekor qilish",
        close: "Yopish",
        remove: "Olib tashlash",
      },
      fields: {
        description: "Tavsif",
        descriptionPlaceholder: "Nimani kutgandingiz va aslida nima bo'ldi?",
      },
      screenshot: {
        label: "Skrinshot",
        capture: "Skrinshot olish",
        capturing: "Skrinshot olinmoqda...",
        attach: "Skrinshot biriktirish",
        retry: "Skrinshotni qayta olish",
        retake: "Qayta olish",
        error: "Skrinshot olib bo'lmadi. Xabarni baribir yuborishingiz mumkin.",
        tooLarge: "Skrinshot 4 MB yoki undan kichik bo'lishi kerak.",
        unsupportedFile: "Skrinshot uchun rasm faylini tanlang.",
        previewAlt: "Xatolik xabari skrinshoti",
        selectInstructions: "Sichqoncha bilan kerakli joyni belgilang · Esc — bekor qilish",
        selectCancel: "Bekor qilish",
      },
      errors: {
        description: "Tavsif kamida 10 ta belgidan iborat bo'lishi kerak.",
        submit: "Xatolik xabarini yuborib bo'lmadi.",
      },
    },
    medicines: {
      noSelectionTitle: "Dori tanlanmagan",
      noSelectionDescription: "Dori qidiring va tafsilotlarini ko'rish uchun natijalardan birini tanlang.",
      actions: {
        addGroup: "Barchasini qo'shish",
        findAnalog: "Analogini topish",
        addToCart: "Savat",
        removeFromCart: "Savatdan olib tashlash",
        showInfo: "Ma'lumotni ko'rsatish",
        showCertificate: "Tegishli sertifikatni ko'rsatish",
        goToOffer: "Taklifga o'tish",
      },
      analogues: {
        title: "Analoglar",
        forMedicine: "Analoglari:",
        errorTitle: "Analoglarni yuklab bo'lmadi",
        emptyTitle: "Analoglar topilmadi",
        emptyDescription: "ATC kodi yoki xalqaro nomi bo'yicha mos dori topilmadi.",
        noMatchesTitle: "Filtr bo'yicha mos natija yo'q",
        noMatchesDescription: "Barcha analoglarni ko'rish uchun dori shakli filtrini tozalang.",
        selectTitle: "Analog tanlang",
        selectDescription: "To'liq tafsilotni ko'rish uchun ro'yxatdan birini tanlang.",
        apply: "Qo'llash",
      },
      dosageForms: {
        tablet: "tabletka",
        capsule: "kapsula",
        syrup: "sirop",
        solution: "eritma",
        suspension: "suspenziya",
        drops: "tomchi",
        injection: "ukol",
        infusion: "infuziya",
        powder: "kukun",
        granule: "granula",
        ointment: "malham",
        cream: "krem",
        gel: "gel",
        lotion: "losyon",
        inhaler: "ingalyator",
        aerosol: "aerozol",
        spray: "sprey",
        suppository: "shamcha",
        pessary: "pessariy",
        enema: "klizma",
        patch: "plastir",
        paste: "pasta",
        pastille: "pastilka",
      },
      units: {
        mg: "mg",
        g: "g",
        mcg: "mkg",
        kg: "kg",
        ml: "ml",
        l: "l",
        iu: "XB",
        percent: "%",
        pcs: "dona",
      },
      finder: {
        title: "Dori qidiruvi",
        description:
          "Dorilarni fuzzy qidiring, brand bo'yicha guruhlangan variantlarni solishtiring va davr bo'yicha narx o'zgarishini tekshiring.",
        placeholder: "Dorilarni qidiring, masalan: paratsetamol 500",
        minChars: "Kamida 3 ta belgi kiriting",
        selected: "Tanlangan",
        pickMedicine: "Dori tanlang",
        startAvg: "Boshlang'ich o'rtacha",
        endAvg: "Yakuniy o'rtacha",
        change: "O'zgarish",
        range: "Narx oralig'i",
        hints: {
          navigate: "harakatlanish",
          select: "tanlash",
          actions: "amallar",
          close: "yopish",
        },
      },
      recommendations: {
        optionLabel: "Bemor matni bo'yicha dorilarni tavsiya qilish",
        optionDescription: "Katalog mosliklarini saralash",
        backToSearch: "Qidiruvga qaytish",
        title: "Dori katalogi tavsiyalari",
        description: "Saralangan katalog mosliklari, dalillar va xavfsizlik ogohlantirishlari.",
        loading: "Saralangan katalog mosliklari yuklanmoqda",
        recommendationCount_one: "{{count}} tavsiya",
        recommendationCount_other: "{{count}} tavsiya",
        candidateCount_one: "{{count}} nomzod tekshirildi",
        candidateCount_other: "{{count}} nomzod tekshirildi",
        emptyTitle: "Katalogda moslik topilmadi.",
        emptyDescription_one: "Jami {{count}} nomzod tekshirildi.",
        emptyDescription_other: "Jami {{count}} nomzod tekshirildi.",
        catalogMatch: "Katalog mosligi",
        evidence: "Dalillar",
        safetyWarnings: "Xavfsizlik ogohlantirishlari",
        errors: {
          emptyQuery: "Katalog bilan solishtirish uchun bemor matnini kiriting.",
          queryTooLong: "Bemor matni 1000 belgidan oshmasligi kerak.",
          limit: "Limit 1 dan 50 gacha bo'lishi kerak.",
          age: "Yosh 0 dan 130 gacha bo'lgan qiymat bo'lishi kerak.",
          load: "Dori tavsiyalarini yuklab bo'lmadi.",
        },
      },
      searchResults: {
        title: "Qidiruv natijalari",
        description:
          "Variantlar quvvat, forma, qadoq va mamlakat bo'yicha farqlarni solishtirishni osonlashtirish uchun guruhlangan.",
        emptyTitle: "Mos natija topilmadi",
        emptyDescription: "Kengroq dori nomini kiriting yoki so'rovdan ortiqcha quvvat/qadoq qismlarini olib tashlang.",
      },
      trend: {
        title: "Narx trendi",
        selectedTitle: "{{name}} narx trendi",
        description: "Qidiruv natijasidan dori tanlab, narx tarixini yuklang.",
        selectedDescription: "/daily-prices?medicine_id={{id}} bo'yicha trend ma'lumoti",
        noMedicineTitle: "Dori tanlanmagan",
        noMedicineDescription: "Natijalardan birini tanlab, umumiy statistika va trend tarixini yuklang.",
        refreshingTitle: "Trend yangilanmoqda...",
        refreshingDescription: "Eng so'nggi narx ma'lumotlari yuklanmoqda.",
        refreshingLabel: "Trend yangilanmoqda…",
        emptyTitle: "Bu davr uchun narx ma'lumoti yo'q",
        emptyDescription: "Dori tanlangan, lekin backend tanlangan vaqt oralig'i uchun trend nuqtalarini qaytarmadi.",
        wholesale: "Ulgurji",
        retail: "Chakana",
        stockTurnover: "Aylanish",
        latestWholesaleOffers: "So'nggi ulgurji takliflar",
        historicalLeaders: "Tarixiy yetakchilar: {{medicine}}",
        loadingLatestOffers: "So'nggi takliflar yuklanmoqda...",
        noLatestWholesaleOffers: "So'nggi ulgurji takliflar yo'q.",
        offersBadgeCheapest: "Eng arzon",
        offersBadgeMostExpensive: "Eng qimmat",
        offersBadgePromo: "Aksiya",
        offersIssued: "Chiqarilgan {{date}}",
        offersExpires: "muddat {{date}}",
        offersOpenSource: "Manba prays-listini ochish",
        noWholesaleHistory: "Ulgurji tarix mavjud emas.",
        noRetailHistory: "Chakana tarix mavjud emas.",
        noHistory: "Tarix mavjud emas.",
        turnoverRate: "Aylanish ko'rsatkichi",
        organizations: "tashkilot",
        median: "Median",
        min: "Min",
        max: "Max",
        movingAverage: "10 kunlik MA",
        wholesaleChartAria: "Ulgurji va chakana trend grafikasi",
        turnoverChartAria: "Aylanish trend grafikasi",
        periodSummary: "{{points}} ta nuqta yuklandi",
        showAll: "Barchasini ko'rsatish",
        comparingMedicines: "{{count}} ta dori solishtirilmoqda",
        enableAtLeastOneMetric: "Ma'lumotlarni ko'rish uchun kamida bitta ko'rsatkichni yoqing.",
        referentWholesale: "Referent (ulgurji)",
        referentRetail: "Referent (chakana)",
      },
      referent: {
        sectionTitle: "Dav. ref. narxlari",
        wholesalePrice: "Ulgurji",
        retailPrice: "Chakana",
        referentPrice: "Referent narx",
        registrationNumber: "Reg. №",
        updated: "Yangilandi {{date}}",
        empty: "Ushbu dori uchun davlat referent narxi yo'q.",
      },
      badges: {
        singleVariant: "Bitta ma'lum variant",
        prescription: "Retsept bilan",
        otc: "Erkin savdo",
        noPrice: "Narx yo'q",
        noAliases: "Sinonimlar yo'q",
        offerCount_one: "{{count}} ulgurji taklif",
        lowestPrice: "{{price}} so'mdan",
        offerCount_other: "{{count}} ulgurji taklif",
        rx: "Retsept",
        inCart: "Savatda",
      },
      containerTypes: {
        ampoule: "Ampula",
        blister: "Blister",
        bottle: "Shisha",
        box: "Quti",
        canister: "Kanistr",
        jar: "Banka",
        packet: "Paket",
        sachet: "Sashe",
        tube: "Tuba",
        vial: "Flakon",
      },
      productTypes: {
        cosmetic: "Kosmetik vosita",
        device: "Tibbiy buyum",
        medicine: "Dori vositasi",
        supplement: "Qo'shimcha",
      },
      labels: {
        form: "Shakl",
        strength: "Kuchi",
        volume: "Hajmi",
        dosageForm: "Dori shakli",
        containerType: "Idish turi",
        pack: "Qadoq",
        country: "Mamlakat",
        vendor: "Ishlab chiqaruvchi",
        score: "Skor",
        id: "ID",
        variantCount_one: "{{count}} variant",
        variantCount_other: "{{count}} variant",
        packPieces: "№{{count}}",
        averagePrice: "O'rtacha narx",
        minimumPrice: "Minimal narx",
        maximumPrice: "Maksimal narx",
      },
      details: {
        title: "Tafsilotlar",
        groups: {
          summary: "Xulosa",
          use: "Qo'llash",
          safety: "Xavfsizlik",
          pharmacology: "Farmakologiya",
          storage: "Saqlash",
        },
        displayName: "Manbadagi nom",
        tradeNameLatin: "Lotincha savdo nomi",
        dosageFormText: "Dori shakli",
        activeSubstance: "Faol modda",
        clinicalPharmacologicalGroup: "Klinik-farmakologik guruh",
        pharmacotherapeuticGroup: "Farmakoterapevtik guruh",
        manufacturerName: "Ishlab chiqaruvchi",
        contactOrganizationName: "Murojaat tashkiloti",
        icd10Codes: "ICD-10 kodlar",
        usedFor: "Nima uchun qo'llanadi",
        indications: "Ko'rsatmalar",
        contraindications: "Qarshi ko'rsatmalar",
        dosageInstructions: "Qo'llash tartibi",
        sideEffects: "Nojo'ya ta'sirlar",
        pregnancyLactation: "Homiladorlik va laktatsiya",
        hepaticImpairment: "Jigar faoliyati buzilishi",
        renalImpairment: "Buyrak faoliyati buzilishi",
        pediatricUse: "Bolalarda qo'llash",
        geriatricUse: "Keksalarda qo'llash",
        specialInstructions: "Maxsus ko'rsatmalar",
        overdose: "Dozani oshirib yuborish",
        composition: "Tarkibi",
        pharmacologicalAction: "Farmakologik ta'sir",
        pharmacokinetics: "Farmakokinetika",
        storageConditions: "Saqlash shartlari",
        pharmacyReleaseTerms: "Dorixonadan berish shartlari",
        drugInteractions: "Dorilar o'zaro ta'siri",
        vendor: "Ishlab chiqaruvchi",
        shelfLifeYear_one: "{{count}} yil",
        shelfLifeYear_other: "{{count}} yil",
        shelfLifeMonth_one: "{{count}} oy",
        shelfLifeMonth_other: "{{count}} oy",
        shelfLife: "Yaroqlilik muddati",
        icdCodes: "ICD kodlar",
        variations: "Variantlar",
        variationsOther: "Boshqa",
        certificates: "Sertifikatlar",
        rxBadge: "Retsept",
        atcLabel: "ATC {{code}}",
        source: "Manba",
        sourceNamed: "{{source}} manbasi",
        openSource: "Manbani ochish",
        openSourceNamed: "{{source}} manbasini ochish",
        sourceUpdated: "yangilandi {{date}}",
        vitalEssential: "Hayotiy zarur va muhim dori",
      },
    },
    account: {
      edit: {
        title: "Profilni tahrirlash",
        description: "Ilovada ko'rinadigan ismingizni yangilang.",
        firstName: "Ism",
        lastName: "Familiya",
        phone: "Telefon raqami",
        phoneHelp: "Raqamni o'zgartirish uchun qo'llab-quvvatlashga murojaat qiling.",
        submit: "O'zgarishlarni saqlash",
        submitting: "Saqlanmoqda…",
        success: "Profil yangilandi.",
        errors: {
          firstNameRequired: "Ismni kiriting.",
          firstNameMax: "Ism juda uzun.",
          lastNameRequired: "Familiyani kiriting.",
          lastNameMax: "Familiya juda uzun.",
          generic: "Profilni yangilab bo'lmadi. Qayta urinib ko'ring.",
        },
      },
      password: {
        title: "Parolni o'zgartirish",
        description: "Hisobingiz uchun yangi parol o'rnating.",
        currentPassword: "Joriy parol",
        newPassword: "Yangi parol",
        confirmPassword: "Yangi parolni tasdiqlang",
        submit: "Parolni yangilash",
        submitting: "Yangilanmoqda…",
        success: "Parol yangilandi.",
        modal: {
          title: "Parolni o'zgartirish",
          description: "Joriy parolni kiriting, so'ng yangisini tanlang.",
          save: "Parolni yangilash",
          saving: "Yangilanmoqda…",
        },
        errors: {
          currentRequired: "Joriy parolni kiriting.",
          currentInvalid: "Joriy parol noto'g'ri.",
          passwordRequired: "Yangi parolni kiriting.",
          passwordMin: "Parol kamida 8 belgidan iborat bo'lishi kerak.",
          passwordMax: "Parol juda uzun.",
          confirmRequired: "Yangi parolni tasdiqlang.",
          mismatch: "Parollar mos kelmaydi.",
          generic: "Parolni o'zgartirib bo'lmadi. Qayta urinib ko'ring.",
        },
      },
      mockBadge: {
        badge: "Namunaviy ma'lumot",
        title: "Bu sahifa ishlab chiqilmoqda",
        description:
          "Bu yerda ko'rsatilayotgan barcha ma'lumotlar namunaviy (mock) bo'lib, haqiqiy hisob ma'lumotlari emas. To'liq funksional keyingi nashrda ulanadi.",
      },
      overview: {
        title: "Hisob",
        description: "Shaxsiy ma'lumotlar va hisob sozlamalari.",
        profile: {
          title: "Shaxsiy ma'lumotlar",
          fullName: "To'liq ism",
          phone: "Telefon raqami",
          email: "Elektron pochta",
          role: "Lavozim",
          organization: "Tashkilot",
          memberSince: "Ro'yxatdan o'tgan sana",
          notSet: "Ko'rsatilmagan",
          edit: "Profilni tahrirlash",
        },
        security: {
          title: "Xavfsizlik",
          description: "Kirish va xavfsizlik sozlamalarini boshqaring.",
          twoFactor: "Ikki bosqichli tasdiqlash",
          twoFactorOff: "O'chiq",
          twoFactorOn: "Yoqilgan",
          changePassword: "Parolni o'zgartirish",
        },
        sessions: {
          title: "Faol seanslar",
          description: "Siz hozir tizimga kirgan qurilmalar.",
          current: "Joriy qurilma",
          signOut: "Chiqish",
          devices: {
            mac: "MacBook Pro · Chrome",
            windows: "Windows PK · Edge",
            ios: "iPhone · Safari",
          },
          locations: {
            tashkent: "Toshkent, O'zbekiston",
            samarkand: "Samarqand, O'zbekiston",
          },
          lastSeen: "{{when}} faol",
          minutesAgo: "{{count}} daqiqa oldin",
          hoursAgo: "{{count}} soat oldin",
          daysAgo: "{{count}} kun oldin",
        },
      },
      billing: {
        title: "To'lovlar",
        description: "Tarif reja, to'lov usullari va hisob-fakturalar.",
        plan: {
          title: "Joriy tarif",
          name: "Pro",
          priceMonthly: "{{amount}} / oy",
          renewsOn: "Yangilanadi: {{date}}",
          manage: "Tarifni boshqarish",
          features: {
            unlimited: "Cheksiz narx-navo yuklash",
            priority: "Birinchi navbatdagi qo'llab-quvvatlash",
            analytics: "Kengaytirilgan analitika",
          },
        },
        paymentMethod: {
          title: "To'lov usuli",
          primary: "Asosiy karta",
          expires: "Amal qilish muddati: {{date}}",
          addNew: "Yangi karta qo'shish",
        },
        invoices: {
          title: "To'lov tarixi",
          empty: "Hozircha hisob-fakturalar yo'q.",
          columns: {
            number: "Raqam",
            date: "Sana",
            amount: "Summa",
            status: "Holat",
            action: "Amal",
          },
          status: {
            paid: "To'langan",
            pending: "Kutilmoqda",
            failed: "Muvaffaqiyatsiz",
          },
          download: "Yuklab olish",
        },
      },
      notificationsPage: {
        title: "Bildirishnomalar",
        description: "Qanday xabarlar olishingizni tanlang va so'nggi faoliyatni ko'ring.",
        preferences: {
          title: "Bildirishnoma sozlamalari",
          description: "Qaysi kanal orqali qanday bildirishnoma kelishi kerakligini sozlang.",
          channels: {
            email: "Elektron pochta",
            push: "Push-bildirishnoma",
            sms: "SMS",
          },
          categories: {
            orders: "Buyurtmalar bo'yicha yangiliklar",
            priceChanges: "Narx o'zgarishlari",
            system: "Tizim xabarlari",
            marketing: "Marketing va aksiyalar",
          },
        },
        feed: {
          title: "So'nggi bildirishnomalar",
          empty: "Yangi bildirishnomalar yo'q.",
          markAllRead: "Barchasini o'qildi deb belgilash",
          unread: "Yangi",
          items: {
            orderConfirmed: {
              title: "Buyurtma tasdiqlandi",
              body: "№1284 buyurtma yetkazib beruvchi tomonidan qabul qilindi.",
              when: "10 daqiqa oldin",
            },
            priceDrop: {
              title: "Narx pasaydi",
              body: 'Kuzatib turgan "Paratsetamol 500mg" narxi 12% ga kamaydi.',
              when: "1 soat oldin",
            },
            stockAlert: {
              title: "Mahsulot qoldig'i kam",
              body: '"Aspirin 100mg" omboringizda kamayib qoldi.',
              when: "3 soat oldin",
            },
            invoiceReady: {
              title: "Yangi hisob-faktura",
              body: "Aprel oyi uchun hisob-faktura tayyor.",
              when: "Kecha",
            },
            systemUpdate: {
              title: "Tizim yangilanishi",
              body: "Platforma yangi funksiyalar bilan yangilandi.",
              when: "2 kun oldin",
            },
          },
        },
      },
    },
    organizations: {
      create: {
        title: "Tashkilotingizni yarating",
        description:
          "Dashboarddan foydalanishdan oldin tashkilot yaratishingiz kerak. Siz uning egasi sifatida belgilanasiz.",
        name: "Tashkilot nomi",
        address: "Manzil",
        city: "Shahar",
        region: "Viloyat",
        regionPlaceholder: "Viloyatni tanlang",
        district: "Tuman",
        type: "Tashkilot turi",
        typePlaceholder: "Turni tanlang",
        logo: "Logotip",
        logoUpload: "Rasm yuklash",
        phones: "Telefon raqamlari",
        addPhone: "Telefon qo'shish",
        removePhone: "Telefonni o'chirish",
        submit: "Tashkilot yaratish",
        submitting: "Yaratilmoqda...",
        success: "Tashkilot muvaffaqiyatli yaratildi.",
        errors: {
          nameRequired: "Tashkilot nomi kiritilishi shart.",
          nameMax: "Nom 255 belgidan oshmasligi kerak.",
          addressMax: "Manzil 500 belgidan oshmasligi kerak.",
          cityMax: "Shahar 255 belgidan oshmasligi kerak.",
          districtMax: "Tuman 255 belgidan oshmasligi kerak.",
          regionInvalid: "To'g'ri viloyatni tanlang.",
          typeRequired: "Tashkilot turini tanlang.",
          typeInvalid: "To'g'ri turini tanlang.",
          phoneInvalid: "Telefon 998XXXXXXXXX formatida bo'lishi kerak.",
          phonesMax: "Eng ko'pi bilan 20 ta telefon qo'shishingiz mumkin.",
          alreadyHasOrganization: "Siz allaqachon tashkilotga tegishlisiz.",
          generic: "Tashkilot yaratib bo'lmadi. Qaytadan urinib ko'ring.",
        },
      },
      types: {
        retail: "Chakana",
        wholesale: "Ulgurji",
      },
      regions: {
        andijon: "Andijon",
        buxoro: "Buxoro",
        fargona: "Farg'ona",
        jizzax: "Jizzax",
        qashqadaryo: "Qashqadaryo",
        qoraqalpogiston: "Qoraqalpog'iston",
        namangan: "Namangan",
        navoiy: "Navoiy",
        samarqand: "Samarqand",
        sirdaryo: "Sirdaryo",
        surxondaryo: "Surxondaryo",
        toshkent: "Toshkent",
        toshkent_viloyati: "Toshkent viloyati",
        xorazm: "Xorazm",
      },
      edit: {
        title: "Tashkilotni tahrirlash",
        description: "Tashkilotingiz ma'lumotlarini yangilang.",
        submit: "O'zgarishlarni saqlash",
        submitting: "Saqlanmoqda...",
        success: "Tashkilot muvaffaqiyatli yangilandi.",
        loadError: "Tashkilotni yuklab bo'lmadi.",
        noOrganization: "Siz hali birorta tashkilotga tegishli emassiz.",
        sections: {
          brandTitle: "Brend",
          brandDescription: "Logotip va tashkilot nomi hamkorlar uchun qanday ko'rinishini belgilaydi.",
          locationTitle: "Joylashuv",
          locationDescription: "Tashkilot qaysi hududda joylashgan?",
          contactTitle: "Aloqa raqamlari",
          contactDescription: "Xaridorlar siz bilan bog'lanish uchun foydalanadi.",
        },
        errors: {
          generic: "Tashkilotni yangilab bo'lmadi. Qaytadan urinib ko'ring.",
        },
      },
      list: {
        searchPlaceholder: "Tashkilotlarni qidirish",
        loadErrorTitle: "Tashkilotlarni yuklab bo'lmadi",
        emptyTitle: "Tashkilot topilmadi",
        emptyDescription: "Boshqa qidiruv so'zini sinab ko'ring.",
        addressMissing: "Manzil ko'rsatilmagan",
        latestPrice: "narx",
        typeFilter: {
          all: "Barchasi",
        },
      },
      info: {
        chooseOrganization: "Tashkilot tanlang",
        detailsHint: "Kontakt ma'lumotlari va Telegram havolalarini ko'rish uchun chapdan tashkilot tanlang.",
        noPhones: "Telefon raqamlari mavjud emas.",
        lastFile: "So'nggi fayl:",
        noGroups: "Ulangan Telegram guruhlari yo'q.",
        notAvailable: "Mavjud emas",
        groupFallback: "Guruh {{id}}",
        approved: "Tasdiqlangan {{date}}",
      },
      telegram: {
        title: "Telegram kanallar",
        description: "Har bir ulangan Telegram kanal uchun so'nggi yangilanish holati.",
        empty: "Hali ulangan Telegram kanal yo'q.",
        lastCrawl: "So'nggi yangilanish",
        lastFile: "So'nggi fayl",
        notCrawled: "Hali yangilanmagan",
        noFile: "Hali fayllar yo'q",
        disabled: "O'chirilgan",
      },
      workspace: {
        title: "Ish maydoni",
        filesDescription: "Yuklangan narx listlarini ko'rib chiqing va bittadan fayl oching.",
        importDescription: "Tanlangan tashkilot uchun yangi workbook importini navbatga qo'ying.",
        tabs: {
          files: "Narx listlari",
          import: "Import",
        },
      },
      files: {
        loadErrorTitle: "Tashkilot tafsilotlarini yuklab bo'lmadi",
        emptyTitle: "Narx list fayllari topilmadi",
        emptyDescription: "Bu tashkilotda hali ko'rinadigan XLS narx listlari yo'q.",
        issueDateMissing: "Chiqarilgan sana mavjud emas",
        status: {
          processing: "Qayta ishlanmoqda",
          completed: "Tayyor",
          failed: "Xatolik",
        },
        rows: "{{count}} qator",
        sheet: "Varaq: {{value}}",
        payment: "To'lov: {{value}}%",
        paginationSummary: "{{total}} tadan {{from}}–{{to}} ko'rsatilmoqda",
        region: "Viloyat",
        allRegions: "Barcha viloyatlar",
        regions: {
          andijon: "Andijon",
          bukhara: "Buxoro",
          fergana: "Farg'ona",
          jizzakh: "Jizzax",
          karakalpakstan: "Qoraqalpog'iston",
          namangan: "Namangan",
          navoiy: "Navoiy",
          qashqadaryo: "Qashqadaryo",
          samarqand: "Samarqand",
          sirdaryo: "Sirdaryo",
          surxondaryo: "Surxondaryo",
          tashkent: "Toshkent",
          xorazm: "Xorazm",
        },
      },
      indexedItems: {
        title: "Indekslangan narx list elementlari",
        description: "Tanlangan fayl uchun backend qaytargan pars qilingan elementlar.",
        filterPlaceholder: "Barcha ustunlar bo'yicha elementlarni filtrlang",
        clickRow: "Tafsilotni ochish uchun qatorni bosing",
        loadErrorTitle: "Narx list elementlarini yuklab bo'lmadi",
        noFileTitle: "Fayl tanlanmagan",
        noFileDescription: "Indekslangan elementlarni ko'rish uchun narx list faylini tanlang.",
        noItemsTitle: "Indekslangan element topilmadi",
        noItemsDescription: "Tanlangan fayl uchun hali pars qilingan elementlar yo'q.",
        fileDescription: "{{fileName}}",
        rowCount: "{{count}} qator",
        downloadXls: "XLS",
        downloadXlsx: "XLSX",
      },
      medicineSheet: {
        title: "Dori tafsilotlari",
        description: "Dori atributlari, narx konteksti va indeks qatori bo'yicha narx o'zgarishini ko'ring.",
        loadErrorTitle: "Dori tafsilotlarini yuklab bo'lmadi",
        missingIdTitle: "Dori ID mavjud emas",
        missingIdDescription: "Bu indeks qatorida bog'langan dori yozuvi mavjud emas.",
        currentRowPrice: "Joriy qator narxi",
        indexedRow: "Indeks qatori",
        trackedSamples: "Kuzatilgan namunalar",
        periodDetail: "Davr: {{period}}",
        priceChange: "Narx o'zgarishi",
        vsPeriodStart: "Davr boshiga nisbatan {{value}}%",
        notEnoughHistory: "Hali yetarli tarix mavjud emas",
        priceMovement: "Narx harakati",
        priceMovementDescription: "Tanlangan dori uchun kunlik o'rtacha, minimal va maksimal narxlar.",
        periodPlaceholder: "Davr",
        noHistoryTitle: "Narx tarixi mavjud emas",
        noHistoryDescription: "Bu dori tanlangan davr uchun yetarli kuzatilgan narx ma'lumotiga ega emas.",
        profileTitle: "Dori profili",
        profileDescription: "Dori katalogi va tanlangan indeks qatoridan asosiy atributlar.",
        indexedContextTitle: "Indeks qatori konteksti",
        indexedContextDescription: "Tanlangan narx list qatoridan olingan source ma'lumot.",
        trendStatus: "Trend holati",
        labels: {
          name: "Nomi",
          internationalName: "Xalqaro nomi",
          dosageForm: "Dori shakli",
          strength: "Kuchi",
          volume: "Hajmi",
          pack: "Qadoq",
          packageQuantity: "Qadoq soni",
          atcCode: "ATC kodi",
          vendorId: "Ishlab chiqaruvchi ID",
          prescription: "Retsept",
          listedPrice: "Ro'yxatdagi narx",
          minMaxPrice: "Min / Max narx",
          priceListFileId: "Narx list fayli ID",
          medicineId: "Dori ID",
          rawName: "Asl nomi",
          vendor: "Ishlab chiqaruvchi",
          expiryDate: "Yaroqlilik muddati",
          issueDate: "Chiqarilgan sana",
          crawledAt: "Yig'ilgan vaqt",
          required: "Talab qilinadi",
          notRequired: "Talab qilinmaydi",
        },
      },
      import: {
        importType: "Import turi",
        dragAndDrop: "yoki shu yerga tashlang",
        importFile: "Import fayli",
        priceList: "Narx listi",
        orderList: "Buyurtma listi",
        noWorkbook: "Workbook tanlanmagan",
        readyToImport: "Bu workbook importga tayyor.",
        invalidFileType: ".xlsx, .xls yoki .csv faylini tanlang.",
        supportedFormats: "Qo'llab-quvvatlanadigan formatlar: .xlsx, .xls, .csv",
        capacityHint: "{{stored}}/{{storageLimit}} fayl saqlangan · {{active}}/{{concurrentLimit}} faol",
        concurrentLimitReached:
          "Bir vaqtning o'zida faqat {{limit}} ta import mumkin. Joriy importlar tugashini kuting.",
        storageLimitReached:
          "Saqlash limiti to'lgan: tashkilot eng ko'pi bilan {{limit}} ta import qilingan faylni saqlaydi. Yangi fayl import qilishdan oldin birortasini o'chiring.",
        queueing: "Import navbatga qo'yilmoqda...",
        signInRequired: "Workbook fayllarni import qilish uchun tizimga kiring.",
        noOrganizationLinked: "Hisobingiz hali tashkilotga bog'lanmagan.",
        selectOrganization: "Fayl import qilishdan oldin tashkilot tanlang.",
        switchOrganization: "Hisobingiz orqali import qilish uchun o'z tashkilotingizga o'ting.",
        queuedNotice: "{{fileName}} import uchun navbatga qo'yildi.",
        queuedNoticeFallback: "Import navbatga qo'yildi.",
        queueTitle: "Import navbati",
        queueDescriptionActive: "Hisobingiz uchun navbatdagi va ishlayotgan workbook joblar.",
        queueDescriptionIdle: "Hozir ishlayotgan job yo'q.",
        waitingToStart: "Boshlanishini kutmoqda",
        inProgress: "Import jarayonda",
        loadingJobs: "Import joblar yuklanmoqda...",
        noActiveTitle: "Faol importlar yo'q",
        noActiveDescription: "Queue progressni shu yerda ko'rish uchun Excel yoki CSV importni boshlang.",
        jobLabel: "Job {{id}}",
        sheetsProgress: "{{completed}}/{{total}} varaq",
        importedSheetsTitle: "Import qilingan varaqlar",
        importedSheetsDescription: "Oldin import qilingan workbooklar. Tarkibini ko'rish uchun qatorni bosing.",
        noImportedSheetsTitle: "Hali import qilingan varaqlar yo'q",
        noImportedSheetsDescription: "Bu yerda ko'rish uchun Excel yoki CSV faylni import qiling.",
        statusCompleted: "Bajarildi",
        statusFailed: "Xatolik",
        deleteAction: "Varaqni o'chirish",
        deleteCancel: "Bekor qilish",
        deleteConfirmAction: "O'chirish",
        deleteConfirmTitle: "Import qilingan varaq o'chirilsinmi?",
        deleteConfirmDescription: "Bu {{name}} va import qilingan qatorlarni butunlay o'chiradi.",
        deleteSuccess: "Import qilingan varaq o'chirildi",
        deleteError: "Import qilingan varaqni o'chirib bo'lmadi",
        listColumns: {
          file: "Fayl",
          rows: "Qatorlar",
          imported: "Import qilingan",
          status: "Holati",
        },
        fileLabel: "Fayl nomi",
        sheetDetailTitle: "Varaq tarkibi",
        sheetDetailDescription: "Bu workbookdan import qilingan qatorlar.",
        loadErrorTitle: "Varaq tarkibini yuklab bo'lmadi",
        loadErrorDescription: "Varaq ma'lumotlarini yuklashda xatolik yuz berdi. Birozdan so'ng qayta urinib ko'ring.",
        sheetRowsSearchPlaceholder: "Nomi, ID, narx yoki xom qiymatlar bo'yicha filtrlash",
        sheetRowsEmpty: "Filtrlarga mos qator topilmadi.",
        sheetRowsCount: "{{from}}-{{to}} / {{total}} ko'rsatilmoqda",
        rows: "qator",
        priceEdit: {
          success: "Narx yangilandi",
          error: "Narxni yangilab bo'lmadi",
          placeholder: "Narx (so'm)",
          ariaLabel: "Narxni tahrirlash",
        },
        summary: {
          matched: "topilgan",
          notFound: "topilmadi",
        },
        columns: {
          name: "Nomi",
          price: "Narx",
          referentWholesalePrice: "Ref. ulgurji",
          vendorName: "Ishlab chiqaruvchi",
          rowIndex: "Qator raqami",
          code: "Kod",
          expiryDate: "Yaroqlilik muddati",
          markup: "Ustama",
          vat: "QQS",
          priceNoVat: "QQS siz narx",
        },
        pricing: {
          column: "Sotuv tavsiyasi",
          targetMargin: "Maqsadli marja",
          payment: "To'lov",
          termAdjustment: "Muddat tuzatmasi",
          region: "Hudud",
          action: "Narx tavsiya etish",
          selected: "{{count}} ta tanlandi",
          costPrice: "Tannarx",
          missingCost: "Har bir tanlangan qator uchun musbat tannarx kiriting.",
          infeasible: "Imkonsiz",
          selectRow: "Narx tavsiyasi uchun qatorni tanlang",
        },
      },
      table: {
        columns: {
          rawName: "Asl nomi",
          vendor: "Ishlab chiqaruvchi",
          packageQuantity: "Qadoq soni",
          expiry: "Yaroqlilik",
          issueDate: "Chiqarilgan sana",
          crawledAt: "Yig'ilgan vaqt",
          price: "Narx",
        },
      },
      priceHover: {
        unknownMedicine: "Dori",
        missingMedicineId: "Bu qator uchun dori (medicine_id) aniqlanmagan.",
        noLiveOffers: "{{medicineId}} ID dori uchun jonli ulgurji takliflar topilmadi.",
        noChartData: "Grafik uchun ma'lumot mavjud emas.",
        daysWindow: "{{count}} kun",
        vsMedian: "medianaga nisbatan",
        recommended: "Tavsiya etilgan",
        referentWholesale: "Referent (ulgurji)",
        referentRetail: "Referent (chakana)",
        offersCount: "Ulg. takliflar",
        vsCheapest: "eng arzonga nisbatan",
        cheaperOffers: "ARZONROQ NARXLAR",
        noCheaper: "Arzonroq taklif yo'q",
        expensiveOffers: "QIMMATROQ NARXLAR",
        noExpensive: "Qimmatroq taklif yo'q",
        expiryError: "Yaroqlilik tarixini yuklab bo'lmadi.",
        expiryEmpty: "Yaroqlilik tarixi mavjud emas.",
        expiryTurnover: "Sotilish tezligi",
        expiryOrgsLabel: "tash.",
        orgFallback: "Tash. {{id}}",
        tabs: {
          wholesale: "Ulgurji",
          retail: "Chakana",
          expiry: "Yaroqlilik",
        },
        series: {
          median: "Mediana",
          min: "Min",
          max: "Maks",
          avg: "10k OO",
          turnoverRate: "Sotilish tezligi",
          offerCount: "Takliflar soni",
        },
      },
      ratings: {
        title: "Tashkilotlar reytingi",
        description:
          "Ulgurji yetkazib beruvchilar so'nggi 90 kun ichida narx raqobatbardoshligi, katalog xilma-xilligi, faollik va aksiyalar bo'yicha reyting.",
        allRegions: "Barcha hududlar",
        count: "{{count}} ta tashkilot",
        errorTitle: "Reytingni yuklab bo'lmadi",
        emptyTitle: "Tashkilotlar yo'q",
        emptyDescription: "Joriy filtrlarga mos keladigan ulgurji tashkilotlar topilmadi.",
        sortOptions: {
          overall: "Umumiy ball",
          cheapest_pct: "Eng arzon narxlar",
          variety: "Keng assortiment",
          medicines: "Eng ko'p eksklyuziv dorilar",
          promotion_pct: "Ko'proq aksiyalar",
          freshness: "Eng faol",
        },
        paymentOptions: {
          p100: "100% to'lov",
          p50: "50% to'lov",
          p30: "30% to'lov",
        },
        scoreLabels: {
          price: "Narx",
          variety: "Assortiment",
          medicines: "Eksklyuziv",
          freshness: "Faollik",
          promotions: "Aksiyalar",
        },
        metrics: {
          medicines: "{{count}} ta dori",
          exclusiveMedicines: "{{count}} ta eksklyuziv",
          cheapest: "{{pct}} arzonroq",
          promo: "{{pct}} aksiyali",
          daysActive: "{{days}}/90 kun faol",
        },
        seeMetrics: "Metrikalar",
        metricsDrawerTitle: "Metrikalar",
        drilldown: {
          openAria: "{{organization}} uchun {{count}} ta {{metric}} dorini ko‘rsatish",
          title: { exclusive: "eksklyuziv", cheapest: "eng arzon", promotion: "aksiyali" },
          description: {
            exclusive: "Oxirgi {{days}} kunda faqat shu yetkazib beruvchida bo‘lgan dorilar.",
            cheapest: "Oxirgi {{days}} kunda eng past narx taklif qilingan dorilar.",
            promotion: "Oxirgi {{days}} kundagi aksiyali takliflar.",
          },
          summary: { matches: "Mosliklar", medicines: "Dorilar", window: "Davr" },
          columns: {
            medicine: "Dori",
            daysOffered: "Taklif kunlari",
            offers: "Takliflar",
            price: "Narx",
            runnerUp: "Keyingi arzon",
            delta: "Farq",
            promo: "Aksiya",
            issued: "Oxirgi sana",
            expiry: "Yaroqlilik",
            vendor: "Ishlab chiqaruvchi",
          },
          competitors: "{{count}} ta yetkazib beruvchiga nisbatan",
          daysWindow: "{{count}} kun",
          searchPlaceholder: "Dorilarni qidirish",
          clearSearch: "Qidiruvni tozalash",
          sortLabel: "Dorilarni saralash",
          sortOptions: {
            matched_days: "Taklif kunlari",
            matched_offers: "Takliflar",
            last_matched_date: "Oxirgi sana",
            matched_price: "Narx",
          },
          errorTitle: "Dorilarni yuklab bo‘lmadi",
          emptyTitle: "Mos dorilar yo‘q",
          emptyDescription: {
            exclusive: "Bu davrda eksklyuziv dorilar topilmadi.",
            cheapest: "Bu davrda eng arzon dorilar topilmadi.",
            promotion: "Bu davrda aksiyali dorilar topilmadi.",
          },
        },
      },
      salesHover: {
        unknownMedicine: "Dori",
        missingMedicineId: "Bu qator uchun dori (medicine_id) aniqlanmagan.",
        loadError: "Savdo ma'lumotlarini yuklab bo'lmadi.",
        daysIncluded: "kun hisoblangan",
        chartTitle: "Chakana savdo oqimi",
        noData: "Savdo ma'lumotlari mavjud emas.",
        avgDailySales: "90k o'rtacha sotilgan",
        medianDailySales: "90k mediana sotilgan",
        totalSales: "Jami sotilgan",
        includedDays: "Foydalanilgan kunlar",
        rank: "O'rin",
        percentile: "Persentil",
        totalDiffVsMedian: "Tengdosh mediana jamiga nisbatan",
        dailyDiffVsMedian: "Tengdosh mediana/kunga nisbatan",
        atcLeaders: "Same ATC code yetakchilari",
        avgPerPharmacy: "O'rt. sotilgan/dorixona",
        daysWithSales: "kun savdo bilan",
        legend: {
          sales: "Sotilgan",
          gain: "Qayta to'ldirilgan",
          net: "Sof",
          peerMedian: "Same ATC code mediana",
        },
      },
      team: {
        roles: {
          owner: "Egasi",
          admin: "Administrator",
          member: "A'zo",
        },
        members: {
          title: "Jamoa a'zolari",
          description: "Tashkilotga kirish huquqiga ega foydalanuvchilar.",
          columns: {
            name: "Ism",
            phone: "Telefon",
            role: "Rol",
            joinedAt: "Qo'shilgan",
          },
          empty: "Hali a'zolar yo'q.",
          remove: "O'chirish",
          removeConfirm: {
            title: "A'zoni o'chirilsinmi?",
            description: "{{name}} tashkilotga kirish huquqini yo'qotadi.",
            confirm: "O'chirish",
          },
          removeSuccess: "A'zo o'chirildi.",
          removeError: "A'zoni o'chirib bo'lmadi.",
          removeForbidden: "Bu a'zoni o'chirishga ruxsatingiz yo'q.",
          removeSelfForbidden: "O'zingizni o'chira olmaysiz.",
        },
        invitations: {
          title: "Takliflar",
          description: "Kutib turgan takliflar avtomatik tarzda muddati tugaydi.",
          empty: "Kutib turgan takliflar yo'q.",
          invite: "Taklif qilish",
          copyLink: "Havolani nusxalash",
          revoke: "Bekor qilish",
          revokeSuccess: "Taklif bekor qilindi.",
          revokeError: "Taklifni bekor qilib bo'lmadi.",
          revokeConflict: "Bu taklifni endi bekor qilib bo'lmaydi.",
          columns: {
            phone: "Telefon",
            email: "Email",
            role: "Rol",
            expiresAt: "Muddati",
          },
          form: {
            title: "A'zoni taklif qilish",
            description: "Telefon raqamiga taklif havolasini yuboring.",
            phone: "Telefon",
            email: "Email (ixtiyoriy)",
            emailPlaceholder: "name@example.com",
            role: "Rol",
            submit: "Taklif yaratish",
            submitting: "Yaratilmoqda…",
            success: "Taklif yaratildi.",
            errors: {
              phoneRequired: "Telefonni kiriting.",
              phoneInvalid: "Yaroqli telefon raqami kiriting.",
              emailInvalid: "Yaroqli email kiriting.",
              duplicate: "Bu telefon allaqachon taklif qilingan yoki a'zo.",
              generic: "Taklif yaratib bo'lmadi.",
            },
          },
          copy: {
            title: "Taklif havolasi",
            description: "Ushbu havolani {{phone}} bilan ulashing.",
            done: "Tayyor",
            error: "Havolani nusxalab bo'lmadi.",
          },
        },
        joinRequests: {
          title: "Qo'shilish so'rovlari",
          description: "Tashkilotga qo'shilmoqchi bo'lgan foydalanuvchilar.",
          columns: {
            name: "Ism",
            phone: "Telefon",
            requestedAt: "Yuborilgan",
          },
          approve: "Qabul qilish",
          reject: "Rad etish",
          approveSuccess: "So'rov qabul qilindi.",
          approveError: "So'rovni qabul qilib bo'lmadi.",
          rejectSuccess: "So'rov rad etildi.",
          rejectError: "So'rovni rad etib bo'lmadi.",
          alreadyDecided: "Bu so'rov allaqachon ko'rib chiqilgan.",
        },
      },
      join: {
        title: "Tashkilotga qo'shilish",
        description: "Tashkilotni qidiring va qo'shilish so'rovini yuboring.",
        greeting: "Xush kelibsiz, {{name}}. Qo'shilish uchun tashkilotni tanlang.",
        searchPlaceholder: "Tashkilotlarni qidirish…",
        empty: "Tashkilot topish uchun yozishni boshlang.",
        noResults: "Mos tashkilotlar topilmadi.",
        requestButton: "So'rov yuborish",
        requestSuccess: "So'rov yuborildi.",
        requestError: "So'rovni yuborib bo'lmadi.",
        errors: {
          alreadyInOrg: "Siz allaqachon tashkilotdasiz.",
          alreadyPending: "Sizda allaqachon faol so'rov bor.",
        },
      },
      pending: {
        title: "So'rov ko'rib chiqilmoqda",
        description: "Sizning so'rovingiz menejer tomonidan ko'rib chiqilmoqda.",
        targetLabel: "Tashkilot",
        cancel: "So'rovni bekor qilish",
        cancelSuccess: "So'rov bekor qilindi.",
        cancelError: "So'rovni bekor qilib bo'lmadi.",
      },
    },
    wholesaleOffers: {
      title: "Ulgurji takliflar",
      totalRows: "{{count}} ta taklif",
      emptyTitle: "Takliflar topilmadi",
      emptyDescription: "Tashkilot filtrini tozalang yoki keyinroq qayting.",
      badges: {
        supplement: "Qo'shimcha",
      },
      footerSummary: {
        offers: "{{count}} ta taklif",
        medicines: "{{count}} ta dori",
        organizations: "{{count}} ta tashkilot",
      },
      promoBadge: "Aksiya",
      promo: {
        popup: {
          ariaLabel: "Aksiya tafsilotlari",
          defaultTitle: "Aksiya",
          priceLabel: "Narx",
          discount: "{{pct}}% chegirma",
          combo: "{{buy}} ta oling, {{bonus}} ta sovg‘a",
          bonusMedicine: "Sovg‘a: {{name}}",
          validFromThrough: "Amal qiladi {{start}} – {{end}}",
        },
      },
      expiresIn_one: "{{count}} oydan keyin tugaydi",
      expiresIn_other: "{{count}} oydan keyin tugaydi",
      expiresIn_zero: "Shu oyda tugaydi",
      expired: "Muddati tugagan",
      batchAge: {
        noExpiry: "Yaroqlilik yo'q",
        tooltip:
          "Ulgurji sotuvchi + dori + yaroqlilik muddati asosida taxmin qilingan. Bu haqiqiy partiya/lot ID emas.",
      },
      leaders: {
        title: "Yetakchilar",
        empty: "Raqobatlashuvchi takliflar tarixi yetarli emas.",
        headers: {
          supplier: "Yetkazib beruvchi",
          wins: "G'alaba",
          rate: "Ulush",
          price: "Narx",
        },
        best: "Eng arzon",
        rankTooltip: "Tanlangan davr uchun yetakchilar jadvalidagi o'rin.",
        winsTooltip:
          "{{dates}} ta taqqoslanadigan sananing {{wins}} tasida eng past narx. Shundan {{ties}} tasi teng natija.",
        rateTooltip: "Yetkazib beruvchi eng past narxni taklif qilgan taqqoslanadigan sanalar ulushi.",
        currentPriceTooltip: "Joriy narx: {{price}} so'm.",
        bestPriceTooltip: "Joriy narx: {{price}} so'm — joriy takliflar orasida eng arzoni.",
        priceGapTooltip: "Joriy narx: {{price}} so'm — eng yaxshi joriy taklifdan {{gap}} so'm qimmat.",
        noCurrentPriceTooltip: "Joriy sanada taklif yo'q.",
        noCurrentPriceLastWinTooltip: "Joriy sanada taklif yo'q. So'nggi g'alaba: {{date}}.",
      },
      actions: {
        cheapestOffer: "Eng arzon taklif",
        mostExpensiveOffer: "Eng qimmat taklif",
        addToCart: "Savat",
        removeFromCart: "Savatdan o'chirish",
        decreaseQuantity: "Sonni kamaytirish",
        increaseQuantity: "Sonni oshirish",
        showPricePlan: "Narxnomani ko'rish",
        showExpirationObservations: "Yaroqlilik kuzatuvlarini ko'rish",
        openMedicine: "Dorini ochish",
        openOrganization: "Tashkilotga o'tish",
        openVendor: "Ishlab chiqaruvchiga o'tish",
        openReferentPrice: "Referent narxni ochish",
        showOnlyMedicine: "Faqat shu dorini ko'rsatish",
        showCheaperSameMedicine: "Shu dorining arzonrog'i",
        showCheaperAnalogue: "Arzonroq analog",
        cheaperSavingsLine: "{{amount}} so'm tejam ({{percent}}%) · {{price}} so'm",
        rawName: "Asl nomi",
        showOnlyOrganization: "Faqat shu tashkilotni ko'rsatish",
        showPurchaseHistory: "Xarid tarixi",
      },
      purchaseHistory: {
        title: "Avval xarid qilingan",
        totalSummary: "Jami xarid qilingan: {{count}} dona",
        orderRow: "Buyurtma #{{shortId}}",
        orderQuantity: "{{count}} dona",
        empty: "Ushbu mahsulotning avvalgi xaridlari yo'q.",
      },
      tone: {
        cheaper: "Bozordan arzon",
        moreExpensive: "Bozordan qimmat",
      },
      toneTooltip: {
        cheaper: "Bu taklif bozor o'rtachasidan {{percent}}% arzonroq.",
        moreExpensive: "Bu taklif bozor o'rtachasidan {{percent}}% qimmatroq.",
      },
      marketTrend: {
        down: "Bozor pasaymoqda",
        up: "Bozor oshmoqda",
        tooltip: "Bu dori va to'lov shartlari uchun 90 kunlik o'rtacha bozor narxi trendi.",
      },
      indicators: {
        cheapestAmongAnalogues: "Analoglar orasida eng arzon",
        onlyAnalogousOffer: "Analoglar orasidagi yagona taklif",
      },
      outlierWarning: "Bu narx odatdan tashqari ko'rinadi va noto'g'ri bo'lishi mumkin.",
      referentPriceCapturedOn: "{{date}} sanasida olingan",
      referentPriceCurrentTooltip: "Joriy referent narx ({{date}} dan kuchga kirgan)",
      referentPriceUpcomingTooltip: "{{price}} {{date}} dan kuchga kiradi",
      referentPriceUpcomingLabel: "{{date}} dan",
      variationFilters: {
        hideInactive: "Faollarni qoldirish",
        showAll: "Hammasini ko'rsatish",
        dosageForm: "Shakl",
        strength: "Dozalash",
        volume: "Hajm",
        pack: "Qadoq",
        containerType: "Idish",
        productType: "Tur",
      },
      columns: {
        medicine: "Dori",
        organization: "Tashkilot",
        region: "Hudud",
        vendor: "Ishlab chiqaruvchi",
        price: "QQS bilan narx",
        normalizedUnitPrice: "Birlik narxi",
        markup: "Ustama",
        referentWholesalePrice: "Ref. ulgurji",
        referentRetailPrice: "Ref. chakana",
        issueDate: "Taklif sanasi",
        expiryDate: "Yaroqlilik muddati",
        batchAge: "Partiya yoshi",
        promotion: "Aksiya",
      },
      columnsMenu: {
        label: "Ustunlar",
        presets: {
          wholesale: "Ulgurji",
          retail: "Chakana",
        },
      },
      filters: {
        organizationPlaceholder: "Tashkilot bo'yicha filter",
        organizationSearchPlaceholder: "Tashkilotni qidirish...",
        organizationEmpty: "Tashkilotlar topilmadi",
        clearOrganization: "Filtrni tozalash",
        organizationIncludedCount_one: "{{count}} ta tanlandi",
        organizationIncludedCount_other: "{{count}} ta tanlandi",
        organizationExcludedCount_one: "{{count}} ta chiqarildi",
        organizationExcludedCount_other: "{{count}} ta chiqarildi",
        organizationIncludeAction: "Qo'shish",
        organizationExcludeAction: "Chiqarish",
        medicinePlaceholder: "Dori bo'yicha filter",
        medicineSearchPlaceholder: "Dorini qidirish...",
        medicineEmpty: "Dorilar topilmadi",
        medicineShowAll: "\"{{query}}\" bo'yicha hammasini ko'rsatish",
        medicineShowAllLabel: "Qidiruv: {{query}}",
        clearMedicine: "Filtrni tozalash",
        regionPlaceholder: "Hudud bo'yicha filter",
        regionSearchPlaceholder: "Hududni qidirish...",
        regionEmpty: "Hududlar topilmadi",
        clearRegion: "Hudud filtrini tozalash",
        clearAll: "Tozalash",
        hasPromotion: "Aksiya",
        withAnalogous: "Analoglar bilan",
        cheapestPerMedicine: "Arzon",
        paymentPercentage: "To'lov foizi",
        paymentPercentageTooltip: "Oldindan to'lov foizi",
        paymentOption: "{{value}}%",
        payment100: "Oldindan to'lov 100%",
        payment25: "25% to'lovli",
        supplement: "Qo'shimchalar",
        hidePriceDecimals: "Kasr raqamlarini yashirish",
        highlighted_one: "{{count}} ta ajratilgan",
        highlighted_other: "{{count}} ta ajratilgan",
      },
      legend: {
        ariaLabel: "Nuqtalar va belgilar izohini ko'rsatish",
        title: "Nuqtalar va belgilar nimani anglatadi",
        rowColors: {
          heading: "Taklif holati nuqtalari",
          onlyOffer: "Bu dori uchun yagona taklif",
          cheapest: "Bu dori uchun eng arzon taklif, analoglarni hisobga olmasdan",
          mostExpensive: "Bu dori uchun eng qimmat taklif",
        },
        statusFilters: {
          cheapest: "Eng arzon",
          mostExpensive: "Eng qimmat",
          onlyOffer: "Yagona taklif",
          notInMarket: "Bozorda yo'q",
        },
        priceTone: {
          heading: "Narx bozor medianasiga nisbatan",
        },
        indicators: {
          heading: "Belgilar",
          outlier: "Narx odatdan tashqari — xarid qilishdan oldin tekshiring",
          promo: "Aksiya mavjud (chegirma yoki N ol + M sovg'a)",
        },
      },
      priceHistoryModal: {
        title: "Tarix",
        current: "Joriy narx",
        periodMin: "Davr min",
        periodMax: "Davr maks",
        change: "Davr o'zgarishi",
        wholesaleRetailSavings: "Ulgurji/chakana farqi",
        priceDifferenceCheaperTooltip: "O'rtacha ulgurji narx chakana narxdan arzonroq.",
        priceDifferenceMoreExpensiveTooltip: "O'rtacha ulgurji narx chakana narxdan qimmatroq.",
        priceDifferenceSameTooltip: "O'rtacha ulgurji va chakana narxlar bir xil.",
        referentWholesale: "Referent (ulgurji)",
        referentRetail: "Referent (chakana)",
        periodSelector: "Davr",
        daysUnit: "kun",
        offerCount: "Takliflar soni",
        offerCountSwitch: "Takliflar sonini ko'rsatish",
        dateOffers: "Sana bo'yicha takliflar",
        tabs: {
          wholesale: "Ulgurji",
          retail: "Chakana",
          expirationObservations: "Yaroqlilik kuzatuvlari",
        },
        daysWindow: "So'nggi {{count}} kun",
        series: {
          median: "Mediana",
          min: "Min",
          max: "Maks",
          avg: "O'rt.",
        },
        loadError: "Narx tarixini yuklab bo'lmadi.",
        empty: "Narx tarixi mavjud emas.",
        hoverHint: "Sana ustiga bosing va o'sha kundagi takliflarni ko'ring.",
        offersOnDate: "{{date}} kundagi takliflar",
        offersError: "Bu sana uchun takliflarni yuklab bo'lmadi.",
        noOffers: "Bu sana uchun takliflar qayd etilmagan.",
        offerAgeLabel_one: "{{count}} kun oldin",
        offerAgeLabel_other: "{{count}} kun oldin",
        offerAgeTooltip:
          "Bu taklif eng so'nggi ma'lum oldingi prays-listdan olingan va bu sana uchun ko'rsatilgan, chunki undan keyingi narx o'zgarishi yoki olib tashlanishi hali ma'lum emas.",
        batchAge: {
          title: "Partiya eskiligi",
          description:
            "Ulgurji sotuvchi + dori + yaroqlilik muddati asosida taxmin qilingan. Bu haqiqiy partiya/lot ID emas.",
          summaryOldest: "Eng eski joriy",
          summaryAverage: "Joriy o'rtacha",
          summaryWholesalers: "Ulgurjilar",
          currentExpiry: "Joriy yaroqlilik: {{date}}",
          firstSeen: "Birinchi ko'rilgan {{date}}",
          observations: "{{count}} kuzatuv",
          timeline: "Yaroqlilik davrlari chizig'i",
          legendPrefix: "Chiziq:",
          legendFresh: "< 30 k",
          legendAging: "30-59 k",
          legendStale: "60+ k",
          legendNoExpiry: "Yaroqlilik yo'q",
          legendLowerBound: "quyi chegara",
          legendWidth: "Kengroq davrlar bir xil yaroqlilik muddati uzoqroq o'zgarmaganini bildiradi.",
          segmentRange: "{{start}} - {{end}}",
          segmentAge: "Taxminiy yosh: {{age}}",
          segmentObservations: "{{count}} kuzatuv",
          segmentHint: "Segment kengligi bu yaroqlilik qiymati qancha vaqt o'zgarmaganini ko'rsatadi.",
          noRuns: "Yaroqlilik davrlari qayd etilmagan.",
          empty: "Partiya eskiligi ma'lumoti mavjud emas.",
          error: "Partiya eskiligini yuklab bo'lmadi.",
        },
      },
    },
    invitations: {
      accept: {
        invalidLink: {
          title: "Yaroqsiz taklif havolasi",
          description: "Havola yo'q yoki noto'g'ri.",
        },
        redirecting: "Kirish sahifasiga o'tilmoqda…",
        processing: "Taklif qabul qilinmoqda…",
        success: {
          title: "Muvaffaqiyatli!",
          description: "Endi siz {{name}} tashkilotining a'zosisiz.",
          descriptionFallback: "Endi siz tashkilot a'zosisiz.",
          continue: "Davom etish",
        },
        errors: {
          goHome: "Boshqaruv paneliga",
          phoneMismatch: {
            title: "Telefon raqami mos kelmaydi",
            description:
              "Bu taklif boshqa raqamga yuborilgan. Siz {{phone}} sifatida tizimga kirgansiz. Tizimdan chiqing va taklif qilingan raqam bilan kiring.",
          },
          notFound: {
            title: "Taklif topilmadi",
            description: "Ushbu taklif havolasi noma'lum yoki o'chirilgan.",
          },
          conflict: {
            title: "Allaqachon tashkilotdasiz",
            description: "Avval joriy tashkilotni tark eting, so'ng taklifni qabul qiling.",
          },
          expired: {
            title: "Taklif muddati o'tgan",
            description: "Yangi taklif yuborishni so'rang.",
          },
          generic: {
            title: "Taklifni qabul qilib bo'lmadi",
            description: "Iltimos, keyinroq qayta urinib ko'ring.",
          },
        },
      },
    },
    vendors: {
      list: {
        searchPlaceholder: "Ishlab chiqaruvchilarni qidirish",
        loadErrorTitle: "Ishlab chiqaruvchilarni yuklab bo'lmadi",
        emptyTitle: "Ishlab chiqaruvchi topilmadi",
        emptyDescription: "Boshqa qidiruv so'zini sinab ko'ring.",
        countryMissing: "Mamlakat ko'rsatilmagan",
      },
      info: {
        chooseVendor: "Ishlab chiqaruvchi tanlang",
        detailsHint: "Tafsilotlarni ko'rish uchun chapdan ishlab chiqaruvchi tanlang.",
        country: "Mamlakat",
        website: "Veb-sayt",
        email: "Email",
        phone: "Telefon",
        address: "Manzil",
        description: "Tavsif",
        notAvailable: "Mavjud emas",
        idLabel: "ID",
        copyId: "ID nusxalash",
        idCopied: "ID nusxalandi",
      },
      label: {
        name: "Ishlab chiqaruvchi",
        country: "Mamlakat",
        countryUnknown: "Mamlakat ko'rsatilmagan",
      },
    },
    certifiedMedicines: {
      title: "Sertifikatlar",
      totalRows: "{{count}} ta yozuv",
      emptyTitle: "Sertifikatlar topilmadi",
      emptyDescription: "Boshqa so'rovni kiriting yoki filtrlarni tozalang.",
      loadErrorTitle: "Sertifikatlarni yuklab bo'lmadi",
      filters: {
        searchPlaceholder: "Nomi, ishlab chiqaruvchi, raqam bo'yicha qidiring…",
        yearPlaceholder: "Yil",
        allYears: "Barcha yillar",
        countryPlaceholder: "Mamlakat",
        allCountries: "Barcha mamlakatlar",
        countrySearchPlaceholder: "Mamlakatlarni qidirish…",
        countryEmpty: "Mamlakatlar topilmadi",
        certifyingBodyPlaceholder: "Sertifikatlovchi organ",
        allCertifyingBodies: "Barcha organlar",
        shelfLifePlaceholder: "Yaroqlilik muddati",
        shelfLifeFromPlaceholder: "Boshlanish",
        shelfLifeToPlaceholder: "Tugash",
        shelfLifeApply: "Qo'llash",
        shelfLifeReset: "Tozalash",
        medicineFilter: "Dori",
        clearAll: "Tozalash",
        unknownOrganization: "Noma'lum tashkilot",
        dialogTitle: "Filtrlar",
        dialogDone: "Tayyor",
        clearSearch: "Qidiruvni tozalash",
      },
      columns: {
        productName: "Nomi",
        year: "Yil",
        manufacturer: "Ishlab chiqaruvchi",
        manufacturerCountry: "Mamlakat",
        certifyingBody: "Sertifikatlovchi organ",
        batchSeries: "Partiya seriyasi",
        registrationNumber: "Reg. №",
        certificateIssuedAt: "Sertifikat sanasi",
        shelfLifeDate: "Yaroqlilik muddati",
        orderedBy: "Buyurtmachi",
      },
      actions: {
        openMedicine: "Dorini ochish",
      },
      detail: {
        title: "Sertifikat tafsilotlari",
        description: "Sertifikatning to'liq yozuvi",
        id: "Yozuv ID",
        crawledAt: "Yig'ilgan sana",
        openSource: "uzpharm-control.uz saytida ochish",
      },
    },
    referentPrices: {
      title: "Referent narxlar",
      emptyTitle: "Referent narx topilmadi",
      emptyDescription: "Boshqa qidiruv kiriting yoki filterlarni tozalang.",
      loadErrorTitle: "Referent narxlarni yuklab bo'lmadi",
      unmatched: "Bog'lanmagan",
      filters: {
        searchPlaceholder: "Nomi, ishlab chiqaruvchi, ro'yxat raqami bo'yicha qidirish…",
        currencyPlaceholder: "Valyuta",
        allCurrencies: "Barcha valyutalar",
        matchStatusPlaceholder: "Bog'lanish",
        allMatchStatuses: "Hammasi",
        matched: "Bog'langan",
        unmatched: "Bog'lanmagan",
        clearAll: "Tozalash",
      },
      columns: {
        tradeName: "Savdo nomi",
        internationalName: "XPN",
        manufacturer: "Ishlab chiqaruvchi",
        package: "Qadoq",
        registrationNumber: "Ro'yxat raqami",
        currency: "Valyuta",
        referentPrice: "Predel narx",
        wholesalePrice: "Ulgurji (so'm)",
        retailPrice: "Chakana (so'm)",
        matchedMedicine: "Dori",
      },
      actions: {
        openMedicine: "Dorini ochish",
      },
      currencies: {
        UZS: "So'm",
        USD: "Dollar",
        EUR: "Yevro",
        RUB: "Rubl",
      },
      detail: {
        title: "Referent narx tafsilotlari",
        description: "Referent narxning to'liq yozuvi",
      },
    },
    expiryStatus: {
      active: "Yaroqli",
      expiringSoon: "Muddati tugayapti",
      expired: "Muddati o'tgan",
    },
    notifications: {
      newPriceList: "Yangi prays-list: {{count}} ta taklif",
      pricesUpdated: "Narxlar yangilandi",
      pricesUpdatedFor: "Narxlar yangilandi — {{organization}}",
      offerCount: "{{count}} ta taklif",
      offerCount_other: "{{count}} ta taklif",
      date: "Sana: {{date}}",
      region: "Hudud: {{region}}",
    },
    cart: {
      title: "Savat",
      description: "Savatdagi dorilar ro'yxati",
      defaultItemLabel: "Mahsulot",
      clearCart: "Savatni tozalash",
      clearConfirm: {
        title: "Savatni tozalashni xohlaysizmi?",
        description: "Barcha dorilar savatdan o'chiriladi. Bu amalni qaytarib bo'lmaydi.",
      },
      cleared: "Savat tozalandi",
      removed: "{{name}} savatdan olib tashlandi",
      added: "{{name}} savatga qo'shildi",
      inCartTooltip: "Savatga qo'shilgan",
      batchAdded: "{{count}} ta dori savatga qo'shildi",
      medicineName: "Dori",
      supplier: "Yetkazib beruvchi",
      manufacturer: "Ishlab chiqaruvchi",
      quantity: "Miqdor",
      price: "Narx",
      total: "Jami",
      itemCount: "{{count}} ta dori",
      totalAmount: "Umumiy summa",
      beforeDiscount: "Chegirmagacha",
      youSaved: "Tejadingiz",
      priceReason: {
        title: {
          promo: "Aksiya chegirmasi",
          combo: "Kombo aksiya",
          priceDropped: "Yetkazib beruvchi narxni tushirdi",
          priceIncreased: "Yetkazib beruvchi narxni oshirdi",
        },
        priceDroppedFromTo: "Avval {{from}}, hozir {{to}}",
        priceIncreasedFromTo: "Avval {{from}}, hozir {{to}}",
        comboEffectiveUnit: "Bir dona uchun haqiqiy narx: {{price}}",
        comboFreeUnits_one: "Ushbu qatorda {{count}} ta bepul dona kiritilgan",
        comboFreeUnits_other: "Ushbu qatorda {{count}} ta bepul dona kiritilgan",
        totalsBreakdownTitle: "Qanday tejadingiz",
        totalsBreakdownReason: {
          promo: "aksiya",
          combo: "kombo {{buy}}+{{bonus}}",
          priceDropped: "narx tushishi",
        },
        totalsBreakdownLineSaved: "tejaldi {{amount}}",
      },
      compactPrices: "Narxlarni minglikda ko'rsatish (1 000 000 → 1mil)",
      expiryDate: "Yaroqlilik: {{date}}",
      issueDate: "Chiqarilgan: {{date}}",
      swap: {
        title: "Yetkazib beruvchini almashtirish",
        cheaperAvailable: "Arzonroq taklif mavjud",
        description: "{{name}} uchun boshqa yetkazib beruvchini tanlang",
        cheaper: "Arzonroq −{{percent}}%",
        moreExpensive: "Qimmatroq +{{percent}}%",
        same: "narx bir xil",
        replace: "Almashtirish",
        empty: "Muqobil yetkazib beruvchilar yoki analoglar topilmadi",
        replaced: "Yetkazib beruvchi {{name}} ga almashtirildi",
        replacedAnalogue: "{{medicine}} ({{name}}) ga almashtirildi",
        currentLabel: "Joriy",
        analogueLabel: "Analog",
        bestPrice: "Eng arzon",
        save: "{{amount}} tejaysiz",
        onlyCheaper: "Faqat arzonlari",
      },
      promo: {
        suggestionsTitle: "Bepul mahsulotlar mavjud",
        bumpQuantity: "{{bonus}} ta bepul olish uchun yana {{delta}} ta {{name}} qo'shing",
        bumpForCrossBonus: "{{bonusQuantity}} ta bepul {{bonusName}} olish uchun yana {{delta}} ta {{name}} qo'shing",
        bumpAction: "Miqdorni oshirish",
        addBonus: "Siz {{bonus}} ta bepul {{name}} olishga haqlisiz",
        addBonusAction: "Savatga qo'shish",
        dismiss: "Yopish",
        openButton: "Aksiyalar",
        modalTitle: "Savatdagi aksiyalar",
        modalDescription: "Har bir bonus uchun yo'l bosib o'tilgan masofa",
        noPromos: "Savatdagi mahsulotlar uchun aksiyalar yo'q.",
        selfBonusFormula: "{{buy}} ta xarid qiling, shu mahsulotning {{bonus}} tasi bepul",
        crossBonusFormula: "{{buy}} ta {{name}} xarid qiling, {{bonus}} ta bepul {{bonusName}} oling",
        bonusItemFallback: "bonus mahsulot",
        progressInCart: "Savatda {{count}} ta",
        bonusUnlocked_one: "{{count}} ta bepul ochildi",
        bonusUnlocked_other: "{{count}} ta bepul ochildi",
        bonusClaimed: "Bonus allaqachon savatda",
        unitsToUnlockSelf_one: "{{bonus}} ta bepul olish uchun yana 1 ta qo'shing",
        unitsToUnlockSelf_other: "{{bonus}} ta bepul olish uchun yana {{count}} ta qo'shing",
        unitsToUnlockCross_one: "{{bonus}} ta bepul {{bonusName}} olish uchun yana 1 ta qo'shing",
        unitsToUnlockCross_other: "{{bonus}} ta bepul {{bonusName}} olish uchun yana {{count}} ta qo'shing",
      },
      combo: {
        bonus: "Bonus",
        bonusCount_one: "+{{count}}",
        bonusCount_other: "+{{count}}",
      },
      empty: {
        title: "Savat bo'sh",
        description: "Dorilar qidiruv sahifasidan savatga qo'shing",
        goToMedicines: "Dorilar sahifasiga o'tish",
      },
      autoSelection: {
        choose:
          "Savatda {{activeCount}} ta mahsulot bor. Uni almashtirasizmi yoki {{recommendationCount}} ta tavsiyani qo'shasizmi?",
        merge: "Birlashtirish",
        replace: "Savatni almashtirish",
        unpriced_one: "{{count}} ta mahsulot uchun yetkazib beruvchini tanlash kerak.",
        unpriced_other: "{{count}} ta mahsulot uchun yetkazib beruvchini tanlash kerak.",
      },
      optimize: {
        title: "Narxlarni optimallashtirish",
        description: "Savatdagi dorilar uchun eng yaxshi narxlarni toping",
        cheapest: {
          title: "Eng arzon narxlar",
          description: "Har bir dori uchun eng past narx",
          issueDate: "Sana",
          notFound: "{{count}} ta dori uchun taklif topilmadi",
          empty: "Takliflar topilmadi",
          applyAll: "Barchasini qo'llash",
          applied: "Eng arzon narxlar qo'llandi",
        },
        maximumTotal: "Buyurtmaning maksimal summasi (UZS)",
        maximumTotalDescription:
          "Xarid limitini belgilang, so‘ng barcha rejalarni kamaytirilgan miqdorlar bilan qayta hisoblang.",
        setMaximumTotal: "Buyurtma limitini belgilash",
        unlimited: "Cheklanmagan",
        recalculate: "Rejalarni qayta hisoblash",
        combinations: {
          title: "Apteka kombinatsiyalari",
          description: "Kamroq aptekadan xarid qilish variantlari",
          option: "Variant {{index}}",
          suppliers: "{{count}} ta apteka",
          extraCost: "+{{amount}} qo'shimcha",
          usePlan: "Tanlash",
          applied: "Variant qo'llandi",
          empty: "Kombinatsiyalar topilmadi",
          requiresMoreOrgs:
            "Eng yaxshi rejalar uchun {{count}} tadan ko'p apteka kerak; quyidagi natijalar to'liq emas.",
          earliestExpiry: "Eng yaqin yaroqlilik: {{date}}",
          missingExpiry: "{{count}} ta mahsulotda yaroqlilik muddati yo'q",
          bestBy: {
            price: "Narx bo'yicha eng yaxshi",
            organization_count: "Eng kam apteka",
            expiry: "Yaroqlilik bo'yicha eng yaxshi",
          },
        },
        mode: {
          label: "Optimallashtirish",
          price: "Narx",
          organization_count: "Aptekalar",
          expiry: "Yaroqlilik",
          all: "Barchasi",
        },
        backToCart: "Savatga qaytish",
        error: "Xatolik yuz berdi",
      },
      analyze: {
        title: "Narx tahlili",
        description: "Savat narxlarini bozor ma'lumotlari bilan solishtiring",
        backToCart: "Savatga qaytish",
        cartPrice: "Savat narxi",
        marketMin: "Eng arzon",
        recommended: "Tavsiya etilgan",
        referentWholesale: "Referent (ulgurji)",
        referentRetail: "Referent (chakana)",
        vsMedian: "Medianga nisbatan",
        offers: "Takliflar",
        aboveMedian: "+{{percent}}% ▲",
        belowMedian: "−{{percent}}% ▼",
        atMedian: "0%",
        notSet: "Belgilanmagan",
        noData: "Bozor ma'lumoti yo'q",
        limitedData: "Kam ma'lumot",
        good: "Yaxshi narx",
        warning: "Yuqori narx",
      },
      stale: {
        banner: {
          title: "Ba'zi mahsulotlar eskirgan",
          description_one: "Buyurtma berishdan oldin {{count}} mahsulotni yangilash kerak.",
          description_other: "Buyurtma berishdan oldin {{count}} ta mahsulotni yangilash kerak.",
        },
        refreshSelected: "Tanlanganlarni yangilash",
        refreshAll: "Barcha eskirganlarni yangilash",
        refreshing: "Yangilanmoqda…",
        selectAll: "Eskirgan barcha mahsulotlarni tanlash",
        reason: {
          price_changed: "Narx o'zgardi: {{from}} → {{to}}",
          issue_date_changed: "Chiqarilgan sana o'zgardi: {{from}} → {{to}}",
          price_list_file_changed: "Manba prayslisti yangilandi ({{date}})",
          price_list_file_changed_no_date: "Manba prayslisti yangilandi",
          offer_removed: "Taklif endi mavjud emas — mahsulotni o'chiring yoki almashtiring",
          no_offer_data: "Joriy taklif ma'lumotlari yo'q — mahsulotni o'chiring yoki almashtiring",
          stale: "Mahsulot ma'lumotlari eskirgan",
        },
        outcome: {
          summary: "{{updated}} yangilandi, {{unchanged}} o'zgarmadi, {{unresolved}} yangilanmadi",
          allUpdated: "Tanlangan barcha mahsulotlar yangilandi",
          unresolved: "Yangilab bo'lmadi — taklif yo'qolgan; mahsulotlarni o'chiring yoki almashtiring",
        },
      },
      priceChangeWarning: {
        title: "Narxlar o'zgardi",
        description_one:
          "{{count}} ta mahsulot narxi siz ko'rgan narxdan farq qiladi. Buyurtma berishdan oldin o'zgarishlarni ko'rib chiqing.",
        description_other:
          "{{count}} ta mahsulot narxlari siz ko'rgan narxlardan farq qiladi. Buyurtma berishdan oldin o'zgarishlarni ko'rib chiqing.",
        unavailableTitle: "Takliflar endi mavjud emas",
        unavailableDescription_one:
          "{{count}} ta mahsulot taklifi endi mavjud emas. Buyurtma berishdan oldin uni o'chiring yoki almashtiring.",
        unavailableDescription_other:
          "{{count}} ta mahsulot takliflari endi mavjud emas. Buyurtma berishdan oldin ularni o'chiring yoki almashtiring.",
        unavailable: "Endi mavjud emas — mahsulotni o'chiring yoki almashtiring",
        continue: "Yangi narxlar bilan davom etish",
      },
    },
    checkout: {
      button: "Buyurtma berish",
      title: "Buyurtmani tasdiqlash",
      description: "Buyurtmangizni ko'rib chiqing va tasdiqlang",
      confirm: "Buyurtma berish",
      cancel: "Bekor qilish",
      notes: "Izoh (ixtiyoriy)",
      notesPlaceholder: "Buyurtma uchun izoh qo'shing...",
      warning: "Barcha mahsulotlarda yetkazib beruvchi, narx va chiqarilgan sana bo'lishi kerak.",
      success: "Buyurtma muvaffaqiyatli yaratildi",
      incompleteItems: "Savatdagi ba'zi mahsulotlar to'liq emas.",
      staleItems: "Savatdagi ba'zi mahsulotlar eskirgan. Buyurtma berishdan oldin yangilang.",
      staleWarning: "Quyidagi mahsulotlar eskirgan — buyurtma berishdan oldin savat sahifasida yangilang.",
    },
    orders: {
      title: "Buyurtmalar",
      description: "Buyurtmalar tarixi",
      downloadFormats: {
        excel: "Excel",
        excelZip: "Excel (ZIP)",
        pdf: "PDF",
      },
      order: "Buyurtma",
      orderId: "Buyurtma ID",
      date: "Sana",
      statusLabel: "Holat",
      suppliers: "Yetkazib beruvchilar",
      totalPrice: "Jami",
      grandTotal: "Umumiy jami",
      subtotal: "Oraliq jami",
      notes: "Izoh",
      medicine: "Dori",
      vendor: "Ishlab chiqaruvchi",
      quantity: "Miqdor",
      unitPrice: "Narx",
      lineTotal: "Jami",
      download: "Yuklab olish",
      expiry: "Yaroqlilik: {{date}}",
      issued: "Chiqarilgan: {{date}}",
      itemCount: "{{count}} ta mahsulot",
      backToOrders: "Buyurtmalarga qaytish",
      notFound: "Buyurtma topilmadi",
      notFoundDescription: "Siz qidirayotgan buyurtma mavjud emas yoki o'chirilgan.",
      pageInfo: "{{page}}-sahifa / {{total}}",
      status: {
        pending: "Kutilmoqda",
        confirmed: "Tasdiqlangan",
        partially_fulfilled: "Qisman bajarilgan",
        fulfilled: "Bajarilgan",
        cancelled: "Bekor qilingan",
      },
      subOrderStatus: {
        pending: "Kutilmoqda",
        confirmed: "Tasdiqlangan",
        shipped: "Yuborilgan",
        delivered: "Yetkazilgan",
        cancelled: "Bekor qilingan",
      },
      empty: {
        title: "Buyurtmalar yo'q",
        description: "Buyurtma bergandan keyin bu yerda ko'rinadi",
        goToCart: "Savatga o'tish",
      },
      reorder: {
        action: "Yana buyurtma berish",
        confirmTitle: "Joriy savatni almashtirasizmi?",
        confirmDescription: "Bu joriy savatni tozalab, ushbu buyurtmadagi mahsulotlarni qo'shadi.",
        cancel: "Bekor qilish",
        confirmAction: "Savatni almashtirish",
        pending: "Almashtirilmoqda...",
      },
    },
    orderImport: {
      title: "Buyurtma fayllarini import qilish",
      description:
        "Buyurtmalar sahifasidan yuklangan bir yoki bir nechta xlsx faylni shu yerga tashlang. Tizim dorilarni jamlaydi, eng arzon yetkazib beruvchini tanlaydi va aksiyalarni hisobga oladi.",
      dropHint: "Xlsx fayllarni shu yerga tashlang",
      fileTypes: "Qo'llab-quvvatlanadi: .xlsx, .xls — 20 tagacha fayl",
      browse: "Fayllarni tanlash",
      remove: "Faylni o'chirish",
      generate_one: "{{count}} fayldan optimallashgan savatni shakllantirish",
      generate_other: "{{count}} fayldan optimallashgan savatni shakllantirish",
      success_one: "Import qilindi. {{count}} ta dori mos topildi.",
      success_other: "Import qilindi. {{count}} ta dori mos topildi.",
      error: "Buyurtmalarni import qilib bo'lmadi",
      goToOrderImport: "Buyurtmalarni import qilish",
      goToPriceImport: "Prays-listlarni import qilish",
      tabs: {
        priceLists: "Prays-listlar",
        orders: "Buyurtmalar",
      },
    },
    orderSheet: {
      backToImport: "Importga qaytish",
      searchPlaceholder: "Aktiv taklif qo'shish uchun dorini qidiring",
      searchHint: "Dori nomini yozishni boshlang — faol ulgurji takliflar topiladi.",
      searching: "Qidirilmoqda...",
      noResults: "Mos takliflar topilmadi.",
      title: "Optimallashgan buyurtma",
      importedTotal: "Import jami",
      optimizedTotal: "Optimallashgandan keyin",
      savingsVsImported: "Importga nisbatan tejov",
      promoSavings: "Aksiya tejovi",
      estimatedTotal: "Taxminiy xarid summasi",
      pricedSubtotal: "Narxi bor pozitsiyalar summasi",
      medicineCount: "Dorilar",
      supplierCount: "Yetkazib beruvchilar",
      unavailableOffers: "Tekshiriladigan takliflar",
      noSupplierOffer: "Yetkazib beruvchi taklifi yo‘q",
      missingOffersHint: "{{count}} ta dori uchun taklif tanlash kerak",
      missingOffersTitle: "{{count}} ta dori uchun yetkazib beruvchi taklifi yo‘q",
      missingOffersDescription:
        "Aynan shu dori yoki analog taklifini tanlang yoxud qatorni o‘chiring. Dorilar sezdirmay tushib qolmasligi uchun buyurtma va XLSX o‘chirilgan.",
      budgetMaximum: "Limit {{amount}}",
      budgetExceededTitle: "Buyurtma mavjud budjetdan oshdi",
      budgetExceededDescription:
        "Joriy summa {{total}}, eng ko‘pi {{maximum}}. Buyurtma yoki eksportdan oldin miqdorni kamaytiring yoki arzonroq yetkazib beruvchini tanlang.",
      allAbc: "Barcha ABC",
      allXyz: "Barcha XYZ",
      changeSupplier: "Yetkazib beruvchini almashtirish",
      changeSupplierTooltip: "Aynan shu dori yoki analog uchun yetkazib beruvchini tanlang",
      supplierChanged: "Yetkazib beruvchi yangilandi",
      supplierChangeFailed: "Yetkazib beruvchini almashtirib bo'lmadi",
      selectedOfferUnavailable: "Tanlangan taklif mavjud emas. Boshqa yetkazib beruvchini tanlang.",
      automaticBestOffer: "Avtomatik eng yaxshi taklif",
      exactOffers: "Aynan shu dori takliflari",
      analogueOffers: "Analog dori takliflari",
      analogueBadge: "Analog",
      analogueOfferNotice:
        "Analoglar alohida ko‘rsatiladi. Tanlanganda birliklar sonini saqlash uchun qadoqlar miqdori o‘zgarishi mumkin.",
      analogueReplacement: "{{original}} o‘rniga",
      unlimited: "Cheklanmagan",
      settings: {
        title: "Hisoblash sozlamalari",
        description: "Saqlangan talab holati va buyurtma parametrlari.",
        legacyDescription: "Bu eski qoralama faqat ko‘rish uchun. Tahrirlash uchun POS orqali yangisini yarating.",
        edit: "Sozlamalarni o‘zgartirish",
        dialogTitle: "Hisoblash sozlamalari",
        dialogDescription:
          "Saqlanganda pozitsiyalar qoralama yaratilgan paytdagi ma’lumotlar asosida qayta hisoblanadi.",
        history: "Savdo davri",
        coverage: "Qoplash davri",
        leadTime: "Yetkazish muddati",
        safety: "Xavfsizlik zaxirasi",
        minimumSales: "Minimal savdo kunlari",
        maximumPacks: "Har bir dori uchun maksimal qadoq",
        maximumTotal: "Buyurtmaning maksimal summasi (UZS)",
        snapshot: "Ma’lumot olingan vaqt",
        days: "{{count}} kun",
        save: "Saqlash va qayta hisoblash",
        recalculating: "Qayta hisoblanmoqda...",
        recalculated: "Avto-tanlov qayta hisoblandi: {{count}} ta dori.",
        failed: "Avto-tanlovni qayta hisoblab bo‘lmadi.",
        quantityWarningTitle: "Qo‘lda o‘zgartirilgan miqdorlar almashtiriladi",
        quantityWarningDescription: "Yetkazib beruvchilar, qo‘shilgan dorilar va o‘chirilgan pozitsiyalar saqlanadi.",
      },
      classification: {
        abc: {
          A: "ABC A: sotuv qiymatidagi ulushi yuqori, moliyaviy jihatdan eng muhim dorilar.",
          B: "ABC B: sotuv qiymatidagi ulushi o‘rtacha.",
          C: "ABC C: sotuv qiymatidagi ulushi past.",
        },
        xyz: {
          X: "XYZ X: haftalik talab barqaror va oldindan aytish oson.",
          Y: "XYZ Y: haftalik talab o‘rtacha o‘zgaruvchan.",
          Z: "XYZ Z: haftalik talab tartibsiz yoki juda o‘zgaruvchan.",
        },
      },
      sort: { quantity: "Miqdor", abc: "ABC", xyz: "XYZ", revenue: "Sotuv qiymati", variability: "O'zgaruvchanlik" },
      explanation: {
        open: "Tavsiya miqdorini tushuntirish",
        title: "Miqdor qanday hisoblandi",
        salesDays: "Yakunlangan savdo kunlari",
        period: "Davr / sotuv kunlari",
        periodValue: "{{history}} / {{sales}} kun",
        sales: "Sotuvlar",
        returns: "Qaytarishlar",
        netDemand: "Sof talab",
        dailyRate: "Kunlik o'rtacha",
        demandDays: "Qoplash + yetkazish + zaxira",
        targetStock: "Maqsadli zaxira",
        currentStock: "Joriy qoldiq",
        shortage: "Yetishmovchilik",
        packSize: "Qadoqdagi birlik",
        initialPacks: "Boshlang'ich qadoqlar",
        inbound: "Yo'ldagi tasdiqlangan",
        beforeMaximum: "Yetkazmalar ayrilgandan so'ng",
        maximum: "Qadoq limiti",
        minimumSalesDays: "Talab etilgan sotuv kunlari",
        generated: "Tavsiya",
        orderBudget: "Buyurtmaning maksimal summasi",
        budgetRequested: "Budjetdan oldingi qadoqlar",
        budgetAdjusted: "Budjetdan keyingi qadoqlar",
        current: "Joriy miqdor",
        abcRevenue: "ABC uchun 90 kunlik sof savdo",
        abc: "ABC {{class}} · ulush {{contribution}}% · jami {{cumulative}}%",
        xyz: "XYZ {{class}} · haftalik o'rtacha {{average}} · {{weeks}} haftada o'zgaruvchanlik {{variation}}%",
        xyzInsufficient: "XYZ: sotuv tarixi yetarli emas",
      },
      supplierTotalRow: "{{count}} ta pozitsiya · {{total}}",
      itemColumns: {
        medicine: "Dori",
        supplier: "Yetkazib beruvchi",
        vendor: "Yetkazib beruvchi / ishlab chiqaruvchi",
        quantity: "Soni",
        importedPrice: "Import narxi",
        selectedPrice: "Narx",
        lineTotal: "Jami",
        lineSavings: "Qatordagi tejov",
        expiry: "Yaroqlilik",
        issueDate: "Chiqarilgan sana",
        actions: "",
      },
      addProduct: "Dori qo'shish",
      addProductDialogTitle: "Qo'shish uchun dori toping",
      createOrder: "Buyurtma yaratish",
      createOrderPending: "Yaratilmoqda...",
      createOrderSuccess: "Buyurtma yaratildi",
      removeRow: "O'chirish",
      removeRowSuccess: "Listdan o'chirildi",
      addRowSuccess: "Listga qo'shildi",
      decreaseQty: "Sonini kamaytirish",
      increaseQty: "Sonini ko'paytirish",
      promoBadge: "Aksiya",
      unresolvedTitle: "Topib bo'lmadi",
      unresolvedDescription:
        "Quyidagi qatorlarni dori bilan moslashtirib bo'lmadi. Asl xlsx faylda dori nomi/yetkazuvchini to'g'rilab, qayta import qiling.",
      unresolvedRow: "{{name}} · soni {{qty}} · {{files}} dan",
      noOptimization: "Bu varaq uchun optimallashtirish mavjud emas.",
      autoSelectionTitle: "Avto-tanlash qoralamasi",
      autoSelectionClaiming: "Dorixona ruxsati tekshirilmoqda va tahrirlanadigan buyurtma ochilmoqda...",
      autoSelectionClaimError:
        "Havola muddati tugagan, boshqa dorixonaga tegishli yoki tashkilot administratori huquqini talab qiladi.",
      autoSelectionAuthError: "Bu qoralamani ochish uchun ushbu dorixona egasi yoki administratori sifatida kiring.",
      autoSelectionRetry: "Qayta urinish",
      autoSelectionSignIn: "Boshqa hisob bilan kirish",
      autoSelectionReason: "{{days}} kunda {{sold}} dona sotildi · qoldiq {{stock}} · yo'ldagi {{inbound}} qadoq",
    },
    priceListFiles: {
      backToImport: "Bosh sahifaga",
      issue: "Chiqarilgan",
      rows: "Qatorlar",
      status: "Holat",
      itemsTitle: "Narx ro'yxati elementlari",
      itemsSearchHint: "Qatorlarni qidirish",
      searchPlaceholder: "Nomi, kodi, yetkazib beruvchi bo'yicha qidiring...",
      empty: "Ushbu fayl uchun qatorlar mavjud emas.",
      cols: {
        name: "Nomi",
        price: "Narx",
        markup: "Ustama",
        paymentPercentage: "To'lov foizi",
        expiry: "Yaroqlilik",
        vendor: "Yetkazib beruvchi",
      },
    },
    overview: {
      loadFailed: "Analitika ma'lumotlarini yuklab bo'lmadi",
      kpi: {
        medicines: "Dorilar",
        medicinesDescription: "Bozor katalogida",
        pharmacies: "Dorixonalar",
        pharmaciesDescription: "Chakana narx ma'lumotlari bilan",
        approvedWholesalers: "Tasdiqlangan ulgurji sotuvchilar",
        wholesalersActive: "{{count}} faol",
        wholesalersActiveDescription: "Faol ulgurji takliflari bilan",
        liveWholesaleOffers: "Faol ulgurji takliflar",
        promotional: "{{count}} aksiya",
        liveWholesaleOffersDescription: "Hozirda bozorda faol",
      },
      retail: {
        title: "Chakana qamrov",
        snapshotLabel: "Narx snapshoti bor dorilar",
        snapshotHelp: "Katalogning {{rate}}% da joriy chakana narxlar bor",
        deliveryLabel: "Yetkazib berishli dorixonalar",
        ofCount: "{{count}} dan",
        lastCrawl: "Oxirgi chakana skan:",
        never: "Hech qachon",
      },
      wholesale: {
        title: "Ulgurji qamrov",
        liveOffersLabel: "Faol takliflari bor dorilar",
        liveOffersHelp: "Katalogning {{rate}}% da faol ulgurji takliflar bor",
        activeWholesalers: "Faol ulgurji sotuvchilar",
        offersWithExpiry: "Amal qilish muddatli takliflar",
        expiringWithin90: "90 kun ichida muddati tugaydiganlar",
        soon: "Tez orada",
        lastCrawl: "Ulgurji takliflar oxirgi skan:",
        latestOfferIssue: "Oxirgi taklif sanasi:",
        latestPriceListDate: "Oxirgi narxlar ro'yxati sanasi:",
      },
      activity: {
        title: "30 kunlik faollik",
        description:
          "So'nggi 30 kun ichidagi yetkazib beruvchilar yangilanishi, faol ulgurji sotuvchilar va takliflar hajmi",
        emptyDescription: "So'nggi 30 kun uchun faollik ma'lumotlari yo'q.",
        supplierUpdates: "Yetkazib beruvchi yangilanishlari",
        activeWholesalers: "Faol ulgurji sotuvchilar",
        wholesaleOffers: "Ulgurji takliflar",
        promotionalOffers: "Aksiya takliflari",
      },
      clickhouse: {
        title: "Analitika tarixi (ClickHouse)",
        statuses: {
          available: "Mavjud",
          partial: "Qisman",
          unavailable: "Mavjud emas",
        },
        unavailableMessage: "Analitika tarixi vaqtincha mavjud emas — yuqoridagi bozor ma'lumotlariga ta'sir qilmaydi.",
        partialMessage: "Tarix qamrovi to'liq emas. Ayrim sanalar yo'q bo'lishi mumkin.",
        retailHistory: "Chakana narxlar tarixi",
        wholesaleHistory: "Ulgurji takliflar tarixi",
        noHistory: "Tarix ma'lumotlari mavjud emas.",
        records: "{{count}} ta yozuv",
        noData: "Ma'lumot yo'q",
      },
    },
  },
} as const;
